import React, { useState, useRef, useEffect, useMemo } from 'react';
import { useNavigate } from 'react-router-dom';
import { getAuth, signOut } from 'firebase/auth';

import { db, storage, getDocs, collection } from '../LoginComp/firebase';
import { doc, setDoc, updateDoc, deleteDoc, addDoc, serverTimestamp, getDoc, query, where, orderBy } from 'firebase/firestore';
import { ref, deleteObject } from 'firebase/storage';
import { createUserWithEmailAndPassword } from "firebase/auth";
import './adminpanel.css';


import {
  getStorage,
  uploadBytes,
  getDownloadURL,
} from "firebase/storage";






import { Eye, EyeOff, Option } from "lucide-react";

function AdminPanel() {
  const [selectedOption, setSelectedOption] = useState("dashboard");
  const [openMenu, setOpenMenu] = useState(null);
  const [isLoggingOut, setIsLoggingOut] = useState(false);
  const dropdownRef = useRef(null);
  const navigate = useNavigate();
  const auth = getAuth();

const [invoices, setInvoices] = useState([]);

//////////////////////////// CREATE USER ACCOUNT /////////////////////////

  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [role, setRole] = useState("");
  const [firstName, setFirstName] = useState("");
  const [lastName, setLastName] = useState("");
  const [specialization, setSpecialization] = useState("");
  const [contactNo, setContactNo] = useState("")
  const [showPassword, setShowPassword] = useState(false);













  // ============ CONSULTANT FORM STATE ============
  const [consultantName, setConsultantName] = useState('');
  const [consultantEmail, setConsultantEmail] = useState('');
  const [consultantSpecialization, setConsultantSpecialization] = useState('');
  const [consultantPhone, setConsultantPhone] = useState('');
  const [consultantLoading, setConsultantLoading] = useState(false);
  const [consultantError, setConsultantError] = useState('');
  const [consultantSuccess, setConsultantSuccess] = useState('');

  // ============ PATIENT FORM STATE ============
  const [formData, setFormData] = useState({
    name: '',
    telephoneNo: '',
    email: '',
    dateOfBirth: '',
    sex: '',
    address: '',
    referredBy: ''
  });
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [success, setSuccess] = useState('');

  // ============ MANAGE PATIENTS STATE ============
  const [patients, setPatients] = useState([]);
  const [searchTerm, setSearchTerm] = useState('');
  const [editingPatient, setEditingPatient] = useState(null);
  const [showEditModal, setShowEditModal] = useState(false);

  const AUTH_CODE = 'Sp@610';

  // ============ MANAGE CONSULTANTS STATE ============
  const [consultants, setConsultants] = useState([]);
  const [consultantsLoading, setConsultantsLoading] = useState(false);
  const [consultantsError, setConsultantsError] = useState('');
  const [consultantsSearch, setConsultantsSearch] = useState('');
  const [consultantsFiltered, setConsultantsFiltered] = useState([]);
  const [showEditConsultantModal, setShowEditConsultantModal] = useState(false);
  const [editingConsultant, setEditingConsultant] = useState(null);

  // ============ DASHBOARD STATE ============
  const [dashboardStats, setDashboardStats] = useState({
    patientCount: 0,
    consultantCount: 0,
    malePatients: 0,
    femalePatients: 0,
    otherPatients: 0,
    specializations: {}
  });
  const [dashboardLoading, setDashboardLoading] = useState(false);
  const [dashboardError, setDashboardError] = useState('');
  const [recentPatients, setRecentPatients] = useState([]);
  const [recentConsultants, setRecentConsultants] = useState([]);

  // ============ CLOSE DROPDOWN ON OUTSIDE CLICK ============
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setOpenMenu(null);
      }
    };
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  const handleSelect = (option) => {
    setSelectedOption(option);
    setOpenMenu(null);
  };

  const toggleDropdown = (menu) => {
    setOpenMenu(openMenu === menu ? null : menu);
  };

  const handleLogout = async () => {
    try {
      setIsLoggingOut(true);
      setOpenMenu(null);
      await signOut(auth);
      localStorage.removeItem('user');
      localStorage.removeItem('userRole');
      sessionStorage.clear();
      navigate('/');
    } catch (error) {
      console.error('Error logging out:', error);
      alert('Error logging out. Please try again.');
      setIsLoggingOut(false);
    }
  };

  // ================================================================
  //                      CREATE PATIENT
  // ================================================================

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!formData.name || !formData.telephoneNo || !formData.dateOfBirth || !formData.sex) {
      setError('Please fill in all required fields (*)');
      return;
    }

    setLoading(true);
    setError('');
    setSuccess('');

    try {
      const patientData = {
        name: formData.name,
        telephoneNo: formData.telephoneNo,
        email: formData.email || '',
        dateOfBirth: formData.dateOfBirth,
        sex: formData.sex,
        address: formData.address || '',
        referredBy: formData.referredBy || '',
        createdAt: serverTimestamp(),
        updatedAt: serverTimestamp()
      };

      const patientsCollection = collection(db, 'patients');
      const docRef = await addDoc(patientsCollection, patientData);
      console.log('Patient created with ID:', docRef.id);

      setSuccess('Patient created successfully! ✅');
      setFormData({
        name: '',
        telephoneNo: '',
        email: '',
        dateOfBirth: '',
        sex: '',
        address: '',
        referredBy: ''
      });

      setTimeout(() => setSuccess(''), 5000);
    } catch (err) {
      console.error('Error creating patient:', err);
      setError('Failed to create patient: ' + err.message);
    } finally {
      setLoading(false);
    }
  };







  //////////////////////////////////////////////  MANAGE PATIENTS   //////////////////////////////////////////////

//   const fetchPatients = async () => {
//     setLoading(true);
//     setError('');
//     try {
//       const patientsCollection = collection(db, 'patients');
//       const patientSnapshot = await getDocs(patientsCollection);
//       const patientList = patientSnapshot.docs.map(doc => ({
//         id: doc.id,
//         ...doc.data()
//       }));
//       setPatients(patientList);
//     } catch (err) {
//       console.error('Error fetching patients:', err);
//       setError('Failed to fetch patients: ' + err.message);
//     } finally {
//       setLoading(false);
//     }
//   };


    





// const normalizePhone = (p) => (p || '').replace(/\D/g, '').slice(-9);
// const normalizeName  = (n) => (n || '').toLowerCase().replace(/[^a-z]/g, '');

// const getOldestInvoice = (patient) => {
//   const pPhone = normalizePhone(patient.telephoneNo);
//   const pName  = normalizeName(patient.name);
//   if (!pPhone || !pName) return null;

//   const matches = invoices.filter(inv =>
//     normalizePhone(inv.patientPhoneNo) === pPhone &&
//     normalizeName(inv.to) === pName
//   );
//   if (matches.length === 0) return null;

//   return matches.slice().sort((a, b) => {
//     const ta = a.createdAtDate ? a.createdAtDate.getTime() : Infinity;
//     const tb = b.createdAtDate ? b.createdAtDate.getTime() : Infinity;
//     return ta - tb;
//   })[0];
// };

// const fetchInvoices = async () => {
//   try {
//     const snap = await getDocs(collection(db, 'invoices'));
//     setInvoices(snap.docs.map(d => {
//       const data = d.data();
//       return {
//         id: d.id,
//         ...data,
//         createdAtDate: data.createdAt?.toDate ? data.createdAt.toDate() : null,
//       };
//     }));
//   } catch (err) {
//     console.error('Error fetching invoices:', err);
//   }
// };







// ---------- helpers ----------
const normalizePhone = (p) => (p || '').replace(/\D/g, '').slice(-9);
const normalizeName  = (n) => (n || '').toLowerCase().replace(/[^a-z]/g, '');

// ---------- component ----------



  // ---------- fetchers ----------
  const fetchInvoices = async () => {
    try {
      const snap = await getDocs(collection(db, 'invoices'));
      setInvoices(snap.docs.map(d => {
        const data = d.data();
        return {
          id: d.id,
          ...data,
          createdAtDate: data.createdAt?.toDate ? data.createdAt.toDate() : null,
        };
      }));
    } catch (err) {
      console.error('Error fetching invoices:', err);
      setError('Failed to fetch invoices: ' + err.message);
    }
  };

  const fetchPatients = async () => {
    setLoading(true);
    setError('');
    try {
      const patientsCollection = collection(db, 'patients');
      const patientSnapshot = await getDocs(patientsCollection);
      const patientList = patientSnapshot.docs.map(doc => ({
        id: doc.id,
        ...doc.data()
      }));
      setPatients(patientList);
    } catch (err) {
      console.error('Error fetching patients:', err);
      setError('Failed to fetch patients: ' + err.message);
    } finally {
      setLoading(false);
    }
  };

  // ---------- initial load (invoices first, then patients) ----------
  useEffect(() => {
    (async () => {
      await fetchInvoices();
      await fetchPatients();
    })();
  }, []);

  // ---------- precomputed oldest invoice per (phone|name) ----------
  const oldestInvoiceByKey = useMemo(() => {
    const map = new Map();
    for (const inv of invoices) {
      const p = normalizePhone(inv.patientPhoneNo);
      const n = normalizeName(inv.to);
      if (!p || !n) continue; // skip phantom matches from empty values
      const key = `${p}|${n}`;
      const t = inv.createdAtDate?.getTime() ?? Infinity;
      const cur = map.get(key);
      const curT = cur?.createdAtDate?.getTime() ?? Infinity;
      if (!cur || t < curT) map.set(key, inv); // keep oldest
    }
    return map;
  }, [invoices]);

  // ---------- helper for a single patient ----------
  const getOldestInvoice = (patient) => {
    const p = normalizePhone(patient.telephoneNo);
    const n = normalizeName(patient.name);
    if (!p || !n) return null;
    return oldestInvoiceByKey.get(`${p}|${n}`) || null;
  };

  // ---------- sorted patients: newest "Patient Added" first, no-date at bottom ----------
  const sortedPatients = useMemo(() => {
    const getTime = (patient) => {
      const inv = getOldestInvoice(patient);
      return inv?.createdAtDate?.getTime() ?? null; // null = no invoice
    };

    return [...patients].sort((a, b) => {
      const ta = getTime(a);
      const tb = getTime(b);

      // patients with no invoice always at the bottom
      if (ta === null && tb === null) return 0;
      if (ta === null) return 1;
      if (tb === null) return -1;

      // newest first  (flip to `ta - tb` for oldest first)
      return tb - ta;
    });
  }, [patients, oldestInvoiceByKey]);











  const deletePatient = async (id) => {
    const userAuth = prompt('Enter authorization code to delete:');
    if (userAuth !== AUTH_CODE) {
      alert('Unauthorized! Invalid authorization code.');
      return;
    }

    if (!window.confirm('Are you sure you want to delete this patient?')) return;

    setLoading(true);
    try {
      const patientRef = doc(db, 'patients', id);
      await deleteDoc(patientRef);

      const patient = patients.find(p => p.id === id);
      if (patient?.profileImage) {
        try {
          const imageRef = ref(storage, patient.profileImage);
          await deleteObject(imageRef);
        } catch (storageError) {
          console.log('No image to delete:', storageError);
        }
      }

      setPatients(patients.filter(p => p.id !== id));
      alert('Patient deleted successfully!');
    } catch (err) {
      console.error('Error deleting patient:', err);
      alert('Error deleting patient: ' + err.message);
    } finally {
      setLoading(false);
    }
  };

  const updatePatient = async (patientData) => {
    const userAuth = prompt('Enter authorization code to update:');
    if (userAuth !== AUTH_CODE) {
      alert('Unauthorized! Invalid authorization code.');
      return;
    }

    setLoading(true);
    try {
      const patientRef = doc(db, 'patients', patientData.id);
      const { id, ...updateData } = patientData;
      await updateDoc(patientRef, updateData);

      setPatients(patients.map(p => p.id === id ? { ...p, ...updateData } : p));
      setShowEditModal(false);
      setEditingPatient(null);
      alert('Patient updated successfully!');
    } catch (err) {
      console.error('Error updating patient:', err);
      alert('Error updating patient: ' + err.message);
    } finally {
      setLoading(false);
    }
  };

  const searchPatients = () => {
    if (!searchTerm.trim()) {
      fetchPatients();
      return;
    }

    setLoading(true);
    try {
      const searchLower = searchTerm.toLowerCase().trim();
      const filtered = patients.filter(patient => {
        const nameMatch = patient.name?.toLowerCase().includes(searchLower) || false;
        const phoneMatch = patient.telephoneNo?.includes(searchTerm) || false;
        const emailMatch = patient.email?.toLowerCase().includes(searchLower) || false;
        return nameMatch || phoneMatch || emailMatch;
      });
      setPatients(filtered);
    } catch (err) {
      setError('Search failed: ' + err.message);
    } finally {
      setLoading(false);
    }
  };

  const handleEdit = (patient) => {
    setEditingPatient({
      ...patient,
      dateOfBirth: patient.dateOfBirth || '',
      telephoneNo: patient.telephoneNo || '',
      email: patient.email || '',
      address: patient.address || '',
      sex: patient.sex || '',
      name: patient.name || ''
    });
    setShowEditModal(true);
  };

  const handleEditSubmit = async (e) => {
    e.preventDefault();
    await updatePatient(editingPatient);
  };

  const handleEditChange = (e) => {
    const { name, value } = e.target;
    setEditingPatient(prev => ({ ...prev, [name]: value }));
  };

  useEffect(() => {
    fetchPatients();
     fetchInvoices();
  }, []);








  // ================================================================
  //                      CREATE CONSULTANT
  // ================================================================

  const handleConsultantSubmit = async (e) => {
    e.preventDefault();

    if (!consultantName || !consultantEmail || !consultantSpecialization || !consultantPhone) {
      setConsultantError('Please fill in all required fields (*)');
      return;
    }

    setConsultantLoading(true);
    setConsultantError('');
    setConsultantSuccess('');

    try {
      const consultantData = {
        name: consultantName,
        email: consultantEmail,
        specialization: consultantSpecialization,
        telephoneNo: consultantPhone,
        createdAt: serverTimestamp(),
        updatedAt: serverTimestamp()
      };

      const consultantCollection = collection(db, 'consultant-app');
      const docRef = await addDoc(consultantCollection, consultantData);
      console.log('Consultant created with ID:', docRef.id);

      setConsultantSuccess('Consultant created successfully! ✅');
      setConsultantName('');
      setConsultantEmail('');
      setConsultantSpecialization('');
      setConsultantPhone('');

      setTimeout(() => setConsultantSuccess(''), 5000);
    } catch (err) {
      console.error('Error creating consultant:', err);
      setConsultantError('Failed to create consultant: ' + err.message);
    } finally {
      setConsultantLoading(false);
    }
  };




  // ================================================================
  //                      MANAGE CONSULTANTS
  // ================================================================

  const fetchConsultants = async () => {
    setConsultantsLoading(true);
    setConsultantsError('');
    try {
      const consultantCollection = collection(db, 'consultant-app');
      const consultantSnapshot = await getDocs(consultantCollection);
      const consultantList = consultantSnapshot.docs.map(doc => ({
        id: doc.id,
        ...doc.data()
      }));
      setConsultants(consultantList);
      setConsultantsFiltered(consultantList);
    } catch (err) {
      console.error('Error fetching consultants:', err);
      setConsultantsError('Failed to fetch consultants: ' + err.message);
    } finally {
      setConsultantsLoading(false);
    }
  };

  const handleDeleteConsultant = async (id) => {
    const userAuth = prompt('Enter authorization code to delete:');
    if (userAuth !== AUTH_CODE) {
      alert('❌ Unauthorized! Invalid authorization code.');
      return;
    }

    if (!window.confirm('Are you sure you want to delete this consultant?')) return;

    setConsultantsLoading(true);
    try {
      const consultantRef = doc(db, 'consultant-app', id);
      await deleteDoc(consultantRef);

      const updatedList = consultants.filter(c => c.id !== id);
      setConsultants(updatedList);
      setConsultantsFiltered(updatedList);
      alert('✅ Consultant deleted successfully!');
    } catch (err) {
      console.error('Error deleting consultant:', err);
      alert('❌ Error deleting consultant: ' + err.message);
    } finally {
      setConsultantsLoading(false);
    }
  };

  const handleUpdateConsultant = async (e) => {
    e.preventDefault();

    const userAuth = prompt('Enter authorization code to update:');
    if (userAuth !== AUTH_CODE) {
      alert('❌ Unauthorized! Invalid authorization code.');
      return;
    }

    setConsultantsLoading(true);
    try {
      const consultantRef = doc(db, 'consultant-app', editingConsultant.id);
      const updateData = {
        name: editingConsultant.name,
        email: editingConsultant.email,
        specialization: editingConsultant.specialization,
        telephoneNo: editingConsultant.telephoneNo,
        updatedAt: serverTimestamp()
      };

      await updateDoc(consultantRef, updateData);

      const updatedList = consultants.map(c =>
        c.id === editingConsultant.id ? { ...c, ...updateData } : c
      );
      setConsultants(updatedList);
      setConsultantsFiltered(updatedList);

      setShowEditConsultantModal(false);
      setEditingConsultant(null);
      alert('✅ Consultant updated successfully!');
    } catch (err) {
      console.error('Error updating consultant:', err);
      alert('❌ Error updating consultant: ' + err.message);
    } finally {
      setConsultantsLoading(false);
    }
  };

  const handleConsultantSearch = (term) => {
    setConsultantsSearch(term);

    if (!term.trim()) {
      setConsultantsFiltered(consultants);
      return;
    }

    const searchLower = term.toLowerCase().trim();
    const filtered = consultants.filter(c =>
      c.name?.toLowerCase().includes(searchLower) ||
      c.email?.toLowerCase().includes(searchLower) ||
      c.specialization?.toLowerCase().includes(searchLower) ||
      c.telephoneNo?.includes(term)
    );
    setConsultantsFiltered(filtered);
  };

  const handleEditClick = (consultant) => {
    setEditingConsultant({
      id: consultant.id,
      name: consultant.name || '',
      email: consultant.email || '',
      specialization: consultant.specialization || '',
      telephoneNo: consultant.telephoneNo || ''
    });
    setShowEditConsultantModal(true);
  };

  useEffect(() => {
    fetchConsultants();
  }, []);






  // ================================================================
  //                      DASHBOARD
  // ================================================================

  const fetchDashboardStats = async () => {
    setDashboardLoading(true);
    setDashboardError('');

    try {
      const patientsSnapshot = await getDocs(collection(db, 'patients'));
      const patientsData = patientsSnapshot.docs.map(doc => ({
        id: doc.id,
        ...doc.data()
      }));

      const consultantsSnapshot = await getDocs(collection(db, 'consultant-app'));
      const consultantsData = consultantsSnapshot.docs.map(doc => ({
        id: doc.id,
        ...doc.data()
      }));

      let male = 0, female = 0, other = 0;
      patientsData.forEach(p => {
        const sex = (p.sex || '').toLowerCase();
        if (sex === 'male') male++;
        else if (sex === 'female') female++;
        else other++;
      });

      const specs = {};
      consultantsData.forEach(c => {
        const spec = c.specialization || 'Unknown';
        specs[spec] = (specs[spec] || 0) + 1;
      });

      setDashboardStats({
        patientCount: patientsData.length,
        consultantCount: consultantsData.length,
        malePatients: male,
        femalePatients: female,
        otherPatients: other,
        specializations: specs
      });

      const sortedPatients = [...patientsData].sort((a, b) => {
        const aTime = a.createdAt?.seconds || 0;
        const bTime = b.createdAt?.seconds || 0;
        return bTime - aTime;
      }).slice(0, 5);
      setRecentPatients(sortedPatients);

      const sortedConsultants = [...consultantsData].sort((a, b) => {
        const aTime = a.createdAt?.seconds || 0;
        const bTime = b.createdAt?.seconds || 0;
        return bTime - aTime;
      }).slice(0, 5);
      setRecentConsultants(sortedConsultants);

    } catch (err) {
      console.error('Error fetching dashboard stats:', err);
      setDashboardError('Failed to load dashboard: ' + err.message);
    } finally {
      setDashboardLoading(false);
    }
  };

  useEffect(() => {
    fetchDashboardStats();
  }, []);

  // ================================================================
  //                      RENDER
  // ================================================================









  ////////////////////////////////////////// birthday wish  /////////////////////////////////////////////////////////


// ============ BIRTHDAY STATE ============
const [birthdayPatients, setBirthdayPatients] = useState([]);
const [todayBirthdays, setTodayBirthdays] = useState([]);
const [upcomingBirthdays, setUpcomingBirthdays] = useState([]);
const [birthdayLoading, setBirthdayLoading] = useState(false);
const [birthdayError, setBirthdayError] = useState('');
const [showBirthdayModal, setShowBirthdayModal] = useState(false);
const [selectedBirthdayPatient, setSelectedBirthdayPatient] = useState(null);
const [birthdayLanguage, setBirthdayLanguage] = useState('english');
const [englishWish, setEnglishWish] = useState('');
const [sinhalaWish, setSinhalaWish] = useState('');

// Calculate age
const calculateAge = (dob) => {
  if (!dob) return 0;
  const birthDate = new Date(dob);
  const today = new Date();
  let age = today.getFullYear() - birthDate.getFullYear();
  const m = today.getMonth() - birthDate.getMonth();
  if (m < 0 || (m === 0 && today.getDate() < birthDate.getDate())) age--;
  return age;
};

// Days until next birthday
const daysUntilBirthday = (dob) => {
  if (!dob) return 999;
  const today = new Date();
  today.setHours(0, 0, 0, 0);
  const birth = new Date(dob);
  const next = new Date(today.getFullYear(), birth.getMonth(), birth.getDate());
  if (next < today) next.setFullYear(today.getFullYear() + 1);
  return Math.ceil((next - today) / (1000 * 60 * 60 * 24));
};

// Format birthday as DD MMM
const formatBirthday = (dob) => {
  if (!dob) return '-';
  const d = new Date(dob);
  return d.toLocaleDateString('en-GB', { day: '2-digit', month: 'short' });
};

// Check if today is birthday
const isBirthdayToday = (dob) => {
  if (!dob) return false;
  const today = new Date();
  const birth = new Date(dob);
  return today.getDate() === birth.getDate() && today.getMonth() === birth.getMonth();
};

// Fetch patients and sort birthdays
const fetchBirthdayPatients = async () => {
  setBirthdayLoading(true);
  setBirthdayError('');
  try {
    const snapshot = await getDocs(collection(db, 'patients'));
    const list = snapshot.docs.map(doc => ({ id: doc.id, ...doc.data() }));
    setBirthdayPatients(list);

    // Today's birthdays
    const today = list.filter(p => isBirthdayToday(p.dateOfBirth));
    setTodayBirthdays(today);

    // Upcoming (next 30 days, excluding today)
    const upcoming = list
      .filter(p => {
        const days = daysUntilBirthday(p.dateOfBirth);
        return days > 0 && days <= 30;
      })
      .sort((a, b) => daysUntilBirthday(a.dateOfBirth) - daysUntilBirthday(b.dateOfBirth));
    setUpcomingBirthdays(upcoming);
  } catch (err) {
    console.error('Error fetching birthdays:', err);
    setBirthdayError('Failed to load birthdays: ' + err.message);
  } finally {
    setBirthdayLoading(false);
  }
};

// Load on mount
useEffect(() => {
  fetchBirthdayPatients();
}, []);

// Open modal with pre-filled wish
const openBirthdayModal = (patient, language) => {
  setSelectedBirthdayPatient(patient);
  setBirthdayLanguage(language);

  const firstName = (patient.name || '').split(' ')[0] || 'Patient';

  // English Wish
  setEnglishWish(
`Happy Birthday, ${patient.name}!

May this special day bring you joy, good health, and happiness throughout the year ahead. 
We're honoured to be part of your recovery journey.


Southern Rehab Care
Galle`
  );

  // Sinhala Wish
  setSinhalaWish(
`සුබ උපන්දිනයක් වේවා, ${patient.name}!

සතුට, යහපත් සෞඛ්‍යය සහ සාර්ථකත්වයෙන් පිරුණු සුන්දර දිනයක් ඔබට ප්‍රාර්ථනා කරමු.
ඔබේ සුවවීමේ ගමනේ කොටසක් වීමට ලැබීම අපට ගෞරවයක්.

*Southern Rehab Care* කාර්ය මණ්ඩලයේ සියලු දෙනාගේ සුභ පැතුම්.

Southern Rehab Care
Galle`
  );

  setShowBirthdayModal(true);
};

// Send via WhatsApp
const sendWhatsApp = (patient, language) => {
  const phone = (patient.telephoneNo || '').replace(/\D/g, '');
  if (!phone) {
    alert('❌ No phone number available for this patient');
    return;
  }
  // Convert Sri Lankan number to international format
  const intlPhone = phone.startsWith('0') ? '94' + phone.substring(1) : phone;
  const message = language === 'english' ? englishWish : sinhalaWish;
  const url = `https://wa.me/${intlPhone}?text=${encodeURIComponent(message)}`;
  window.open(url, '_blank');
};

// Send via SMS
const sendSMS = (patient, language) => {
  const phone = (patient.telephoneNo || '').replace(/\D/g, '');
  if (!phone) {
    alert('❌ No phone number available for this patient');
    return;
  }
  const message = language === 'english' ? englishWish : sinhalaWish;
 
  const url = `sms:${phone}?body=${encodeURIComponent(message)}`;
  window.location.href = url;
};





////////////////////////////// create user account  ///////////////////////////////



const createAccount = async () => {
    try {
      // Create user in Firebase Authentication
      const userCredential = await createUserWithEmailAndPassword(auth, email, password);
      const userId = userCredential.user.uid;


      // Save user details in Firestore
      await setDoc(doc(db, "users", userId), {
        email,
        role,
        firstName,
        lastName,
        specialization,
        contactNo,
      });



      alert("User created successfully!");
      // Reset the form
      setEmail("");
      setPassword("");
      setRole("");      
      setFirstName("");
      setLastName("");
      setSpecialization("");
      setContactNo("");
    } catch (error) {
      console.error("Error creating user:", error.message);
      alert(error.message);
    }
  };





////////////////////////////// view all user account  ///////////////////////////////

// ---- State ----
const [users, setUsers] = useState([]);
const [loadingUsers, setLoadingUsers] = useState(false);
const [userSearch, setUserSearch] = useState("");

const [deleteModal, setDeleteModal] = useState({ open: false, user: null });
const [authCode, setAuthCode] = useState("");
const [authError, setAuthError] = useState("");

const [editModal, setEditModal] = useState({ open: false, user: null });
const [editForm, setEditForm] = useState({
  firstName: "",
  lastName: "",
  role: "",
  specialization: "",
  contactNo: "",
});

const AUTHORISATION_CODE = "Sp@610";

// ---- Fetch Users ----
const fetchUsers = async () => {
  try {
    setLoadingUsers(true);
    const querySnapshot = await getDocs(collection(db, "users"));
    const usersList = querySnapshot.docs.map((doc) => ({
      id: doc.id,
      ...doc.data(),
    }));
    setUsers(usersList);
  } catch (error) {
    console.error("Error fetching users:", error);
    alert("Failed to load users.");
  } finally {
    setLoadingUsers(false);
  }
};

// Load users on mount
useEffect(() => {
  fetchUsers();
}, []);

// ---- Filtered Users (Search) ----
const filteredUsers = users.filter((u) => {
  const term = userSearch.toLowerCase();
  return (
    (u.firstName?.toLowerCase() || "").includes(term) ||
    (u.lastName?.toLowerCase() || "").includes(term) ||
    (u.email?.toLowerCase() || "").includes(term) ||
    (u.role?.toLowerCase() || "").includes(term)
  );
});

// ---- Delete ----
const openDeleteModal = (user) => {
  setDeleteModal({ open: true, user });
  setAuthCode("");
  setAuthError("");
};

const confirmDelete = async () => {
  if (authCode !== AUTHORISATION_CODE) {
    setAuthError("❌ Invalid authorisation code.");
    return;
  }

  try {
    await deleteDoc(doc(db, "users", deleteModal.user.id));
    setUsers((prev) => prev.filter((u) => u.id !== deleteModal.user.id));
    alert("✅ User deleted successfully.");
    setDeleteModal({ open: false, user: null });
    setAuthCode("");
    setAuthError("");
  } catch (error) {
    console.error("Error deleting user:", error);
    alert("Failed to delete user.");
  }
};

// ---- Edit ----
const openEditModal = (user) => {
  setEditModal({ open: true, user });
  setEditForm({
    firstName: user.firstName || "",
    lastName: user.lastName || "",
    role: user.role || "",
    specialization: user.specialization || "",
    contactNo: user.contactNo || "",
  });
};

const confirmEdit = async () => {
  try {
    const userRef = doc(db, "users", editModal.user.id);
    await updateDoc(userRef, {
      firstName: editForm.firstName,
      lastName: editForm.lastName,
      role: editForm.role,
      specialization: editForm.specialization,
      contactNo: editForm.contactNo,
      // email NOT updated — read-only
    });

    // Update local state
    setUsers((prev) =>
      prev.map((u) =>
        u.id === editModal.user.id ? { ...u, ...editForm } : u
      )
    );

    alert("✅ User updated successfully.");
    setEditModal({ open: false, user: null });
  } catch (error) {
    console.error("Error updating user:", error);
    alert("Failed to update user.");
  }
};





///////////////////////////////// create recovery profile /////////////////////////////////////

const [patientSearch, setPatientSearch] = useState("");
const [allPatients, setAllPatients] = useState([]);
const [showSuggestions, setShowSuggestions] = useState(false);
const [selectedPatient, setSelectedPatient] = useState(null);
const [savingRecovery, setSavingRecovery] = useState(false);


const [recoveryForm, setRecoveryForm] = useState({
  recoveryStartDate: "",
  height: "",
  weight: "",
  condition: "",
  menarche : "",
  assignedConsultant: "",
  nextFollowUp: "",
  treatmentPlan: "",
  remarks: "",

  // Photos
  xrayPhoto: null,
  firstDayPicture: null,
});

// ---- Load patients once (for search suggestions) ----
const loadAllPatients = async () => {
  try {
    const snap = await getDocs(collection(db, "patients"));
    const list = snap.docs.map((d) => ({ id: d.id, ...d.data() }));
    setAllPatients(list);
  } catch (err) {
    console.error("Error loading patients:", err);
  }
};

// ---- Load consultants (from consultant-app collection) ----
const loadConsultants = async () => {
  setConsultantsLoading(true);
  setConsultantsError("");
  try {
    const snap = await getDocs(collection(db, "consultant-app"));
    const list = snap.docs.map((d) => ({ id: d.id, ...d.data() }));
    setConsultants(list);
  } catch (err) {
    console.error("Error loading consultants:", err);
    setConsultantsError("Failed to load consultants.");
  } finally {
    setConsultantsLoading(false);
  }
};

// ---- Load on mount ----
useEffect(() => {
  loadAllPatients();
}, []);

// Load consultants when the recovery profile tab opens
useEffect(() => {
  if (selectedOption === "createRecoveryProfile") {
    loadConsultants();
  }
}, [selectedOption]);


// ---- Filtered search results (top 8) ----
const searchResults = allPatients
  .filter((p) => {
    const term = patientSearch.toLowerCase().trim();
    if (!term) return false;
    return (
      (p.name?.toLowerCase() || "").includes(term) ||
      (p.telephoneNo?.toLowerCase() || "").includes(term) ||
      (p.email?.toLowerCase() || "").includes(term)
    );
  })
  .slice(0, 8);



// ---- Select patient (auto-fill) ----
const selectPatient = (patient) => {
  setSelectedPatient(patient);
  setPatientSearch(patient.name || "");
  setShowSuggestions(false);
  resetForm();
};


// ---- Reset form ----
const resetForm = () => {
  setRecoveryForm({
    recoveryStartDate: "",
    height: "",
    weight: "",
    condition: "",
    menarche: "",
    assignedConsultant: "",
    nextFollowUp: "",
    treatmentPlan: "",
    remarks: "",

        // Photos
    xrayPhoto: null,
    firstDayPicture: null,
  });
};







const uploadRecoveryPhoto = async (file, patientId, photoType) => {
  if (!file) return "";

  // Optional file size limit: 10 MB
  if (file.size > 10 * 1024 * 1024) {
    throw new Error(
      `${photoType} must be smaller than 10 MB.`
    );
  }

  // Create a unique filename
  const timestamp = Date.now();

  const safeFileName = file.name.replace(
    /[^a-zA-Z0-9.-]/g,
    "_"
  );

  const storagePath =
    `recovery-profile/${patientId}/${photoType}/${timestamp}_${safeFileName}`;

  const storageRef = ref(storage, storagePath);

  // Upload file
  await uploadBytes(storageRef, file);

  // Get public download URL
  const downloadURL = await getDownloadURL(storageRef);

  return downloadURL;
};







// ---- Save to recovery-profile collection ----
// const saveRecoveryProfile = async () => {
//   // Validation
//   if (!recoveryForm.recoveryStartDate) {
//     alert("⚠️ Please select a Recovery Start Date.");
//     return;
//   }

//   if (!recoveryForm.assignedConsultant) {
//     alert("⚠️ Please select an Assigned Consultant.");
//     return;
//   }

//   if (!selectedPatient) {
//     alert("⚠️ Please select a patient.");
//     return;
//   }

//   try {
//     setSavingRecovery(true);

//     // Prevent duplicates
//     const dupCheck = await getDocs(
//       query(
//         collection(db, "recovery-profile"),
//         where("patientId", "==", selectedPatient.id)
//       )
//     );

//     if (!dupCheck.empty) {
//       const confirmOverwrite = window.confirm(
//         "⚠️ A recovery profile already exists for this patient. Create another?"
//       );

//       if (!confirmOverwrite) {
//         setSavingRecovery(false);
//         return;
//       }
//     }

//     // Find the full consultant object
//     const selectedConsultantObj = consultants.find(
//       (c) => c.name === recoveryForm.assignedConsultant
//     );

//     // Normalize height and weight before saving
//     const heightValue = recoveryForm.height
//       ? `${parseFloat(recoveryForm.height)} cm`
//       : "";

//     const weightValue = recoveryForm.weight
//       ? `${parseFloat(recoveryForm.weight)} kg`
//       : "";

//     await addDoc(collection(db, "recovery-profile"), {
//       // Patient info
//       patientId: selectedPatient.id,
//       patientName: selectedPatient.name || "",
//       patientEmail: selectedPatient.email || "",
//       patientPhone: selectedPatient.telephoneNo || "",
//       patientDob: selectedPatient.dateOfBirth || "",
//       patientGender: selectedPatient.sex || "",
//       patientAddress: selectedPatient.address || "",

//       // Recovery fields
//       recoveryStartDate: recoveryForm.recoveryStartDate,

//       // Save with units
//       height: heightValue,
//       weight: weightValue,

//       condition: recoveryForm.condition,
//       menarche: recoveryForm.menarche,

//       assignedConsultant: recoveryForm.assignedConsultant,
//       assignedConsultantId: selectedConsultantObj?.id || null,
//       assignedConsultantSpecialization:
//         selectedConsultantObj?.specialization || "",
//       assignedConsultantEmail: selectedConsultantObj?.email || "",

//       nextFollowUp: recoveryForm.nextFollowUp,
//       treatmentPlan: recoveryForm.treatmentPlan,
//       remarks: recoveryForm.remarks,

//       createdAt: serverTimestamp(),
//       createdBy: auth.currentUser?.email || "unknown",
//     });

//     alert("✅ Recovery profile saved successfully!");

//     setSelectedPatient(null);
//     setPatientSearch("");
//     resetForm();

//   } catch (err) {
//     console.error("Error saving recovery profile:", err);
//     alert("❌ Failed to save recovery profile: " + err.message);
//   } finally {
//     setSavingRecovery(false);
//   }
// };

const saveRecoveryProfile = async () => {
  // Validation
  if (!recoveryForm.recoveryStartDate) {
    alert("⚠️ Please select a Recovery Start Date.");
    return;
  }

  if (!recoveryForm.assignedConsultant) {
    alert("⚠️ Please select an Assigned Consultant.");
    return;
  }

  if (!selectedPatient) {
    alert("⚠️ Please select a patient.");
    return;
  }

  try {
    setSavingRecovery(true);

    // Prevent duplicates
    const dupCheck = await getDocs(
      query(
        collection(db, "recovery-profile"),
        where("patientId", "==", selectedPatient.id)
      )
    );

    if (!dupCheck.empty) {
      const confirmOverwrite = window.confirm(
        "⚠️ A recovery profile already exists for this patient. Create another?"
      );

      if (!confirmOverwrite) {
        setSavingRecovery(false);
        return;
      }
    }

    // Find the full consultant object
    const selectedConsultantObj = consultants.find(
      (c) => c.name === recoveryForm.assignedConsultant
    );

    // Normalize height and weight
    const heightValue = recoveryForm.height
      ? `${parseFloat(recoveryForm.height)} cm`
      : "";

    const weightValue = recoveryForm.weight
      ? `${parseFloat(recoveryForm.weight)} kg`
      : "";

    // ==========================================
    // UPLOAD X-RAY PHOTO
    // ==========================================

    let xrayPhotoURL = "";

    if (recoveryForm.xrayPhoto) {
      xrayPhotoURL = await uploadRecoveryPhoto(
        recoveryForm.xrayPhoto,
        selectedPatient.id,
        "xrayPhoto"
      );
    }

    // ==========================================
    // UPLOAD FIRST DAY PICTURE
    // ==========================================

    let firstDayPictureURL = "";

    if (recoveryForm.firstDayPicture) {
      firstDayPictureURL = await uploadRecoveryPhoto(
        recoveryForm.firstDayPicture,
        selectedPatient.id,
        "firstDayPicture"
      );
    }

    // ==========================================
    // SAVE RECOVERY PROFILE
    // ==========================================

    await addDoc(collection(db, "recovery-profile"), {
      // Patient info
      patientId: selectedPatient.id,
      patientName: selectedPatient.name || "",
      patientEmail: selectedPatient.email || "",
      patientPhone: selectedPatient.telephoneNo || "",
      patientDob: selectedPatient.dateOfBirth || "",
      patientGender: selectedPatient.sex || "",
      patientAddress: selectedPatient.address || "",

      // Recovery fields
      recoveryStartDate: recoveryForm.recoveryStartDate,

      // Height / Weight
      height: heightValue,
      weight: weightValue,

      condition: recoveryForm.condition,
      menarche: recoveryForm.menarche,

      // Consultant
      assignedConsultant: recoveryForm.assignedConsultant,
      assignedConsultantId: selectedConsultantObj?.id || null,
      assignedConsultantSpecialization:
        selectedConsultantObj?.specialization || "",
      assignedConsultantEmail:
        selectedConsultantObj?.email || "",

      // Follow-up
      nextFollowUp: recoveryForm.nextFollowUp,

      // Treatment
      treatmentPlan: recoveryForm.treatmentPlan,
      remarks: recoveryForm.remarks,

      // ==========================================
      // PHOTO URLS
      // ==========================================
      xrayPhoto: xrayPhotoURL,
      firstDayPicture: firstDayPictureURL,

      // Metadata
      createdAt: serverTimestamp(),
      createdBy: auth.currentUser?.email || "unknown",
    });

    alert("✅ Recovery profile saved successfully!");

    setSelectedPatient(null);
    setPatientSearch("");

    resetForm();

  } catch (err) {
    console.error("Error saving recovery profile:", err);

    alert(
      "❌ Failed to save recovery profile: " +
      err.message
    );
  } finally {
    setSavingRecovery(false);
  }
};








//////////////////////////////////// view all recovery profile / manage recovery profile   //////////////////////////// 

// ---- Main List ----
const [vrpProfiles, setVrpProfiles] = useState([]);
const [vrpLoading, setVrpLoading] = useState(false);
const [vrpError, setVrpError] = useState("");
const [vrpSearch, setVrpSearch] = useState("");

// ---- Maintain Modal ----
const [maintainModal, setMaintainModal] = useState({ open: false, profile: null });


const [maintainForm, setMaintainForm] = useState({
  recoveryStartDate: "",
  height: "",
  condition: "",
  menarche: "",
  assignedConsultant: "",
  weight: "",
  treatmentPlan: "",
  remarks: "",

  // Initial photos
  xrayPhoto: "",
  firstDayPicture: "",

  stages: [],
});



const [savingMaintain, setSavingMaintain] = useState(false);

// ---- View Modal ----
const [viewModal, setViewModal] = useState({ open: false, profile: null });

// ---- Delete Modal ----
const [deleteModalRecovery, setDeleteModalRecovery] = useState({ open: false, profile: null });
const [vrpAuthCode, setVrpAuthCode] = useState("");
const [vrpAuthError, setVrpAuthError] = useState("");

// ---- Fetch all recovery profiles ----
const fetchRecoveryProfiles = async () => {
  setVrpLoading(true);
  setVrpError("");
  try {
    const snap = await getDocs(collection(db, "recovery-profile"));
    const list = snap.docs.map((d) => ({ id: d.id, ...d.data() }));
    // Sort: newest first (fallback if no createdAt)
    list.sort((a, b) => (b.createdAt?.seconds || 0) - (a.createdAt?.seconds || 0));
    setVrpProfiles(list);
  } catch (err) {
    console.error("Error fetching recovery profiles:", err);
    setVrpError("Failed to load recovery profiles: " + err.message);
  } finally {
    setVrpLoading(false);
  }
};

// Load on tab open
useEffect(() => {
  if (selectedOption === "viewRecoveryProfile") {
    fetchRecoveryProfiles();
  }
}, [selectedOption]);

// ---- Filter ----
const vrpFiltered = vrpProfiles.filter((p) => {
  const term = vrpSearch.toLowerCase().trim();
  if (!term) return true;
  return (
    (p.patientName?.toLowerCase() || "").includes(term) ||
    (p.patientPhone?.toLowerCase() || "").includes(term) ||
    (p.condition?.toLowerCase() || "").includes(term) ||
    (p.address?.toLowerCase() || "").includes(term) ||
    (p.assignedConsultant?.toLowerCase() || "").includes(term)
  );
});

// ============================================================
// MAINTAIN MODAL
// ============================================================
// const openMaintainModal = (profile) => {
//   setMaintainModal({ open: true, profile });

//   setMaintainForm({
//     recoveryStartDate: profile.recoveryStartDate || "",
//     height: profile.height || "",
//     condition: profile.condition || "",
//     weight: profile.weight || "",
//     assignedConsultant: profile.assignedConsultant || "",
//     menarche: profile.menarche || "",
//     treatmentPlan: profile.treatmentPlan || "",
//     remarks: profile.remarks || "",

//     // Load saved photos
//     xrayPhoto: profile.xrayPhoto || "",
//     firstDayPicture: profile.firstDayPicture || "",

//     stages: Array.isArray(profile.stages) ? profile.stages : [],
//   });
// };



const openMaintainModal = (profile) => {
  const normalizedStages = Array.isArray(
    profile.stages
  )
    ? profile.stages.map((stage) => ({
        ...stage,

        followupheight:
          stage.followupheight || "",

        followupweight:
          stage.followupweight || "",

        nextfollowUpDate:
          stage.nextfollowUpDate || "",

        photos: Array.isArray(stage.photos)
          ? stage.photos.map((photo) => ({
              ...photo,

              // New Storage format
              url: photo.url || "",

              // Old Base64 format
              dataUrl: photo.dataUrl || "",

              name: photo.name || "",
            }))
          : [],
      }))
    : [];

  setMaintainModal({
    open: true,
    profile,
  });

  setMaintainForm({
    recoveryStartDate:
      profile.recoveryStartDate || "",

    height:
      profile.height || "",

    condition:
      profile.condition || "",

    weight:
      profile.weight || "",

    assignedConsultant:
      profile.assignedConsultant || "",

    menarche:
      profile.menarche || "",

    treatmentPlan:
      profile.treatmentPlan || "",

    remarks:
      profile.remarks || "",

    xrayPhoto:
      profile.xrayPhoto || "",

    firstDayPicture:
      profile.firstDayPicture || "",

    stages: normalizedStages,
  });
};





// const addNewStage = () => {
//   setMaintainForm((prev) => ({
//     ...prev,
//     stages: [
//       ...prev.stages,
//       { stageName: "", followUpDate: "", notes: "", photos: [] },
//     ],
//   }));
// };



const addNewStage = () => {
  setMaintainForm((prev) => ({
    ...prev,
    stages: [
      ...prev.stages,
      {
        stageName: "",
        followUpDate: "",
        followupheight: "",
        followupweight: "",
        nextfollowUpDate: "",
        notes: "",
        photos: [],
      },
    ],
  }));
};



const removeStage = (idx) => {
  setMaintainForm((prev) => ({
    ...prev,
    stages: prev.stages.filter((_, i) => i !== idx),
  }));
};

const updateStage = (idx, field, value) => {
  setMaintainForm((prev) => ({
    ...prev,
    stages: prev.stages.map((s, i) =>
      i === idx ? { ...s, [field]: value } : s
    ),
  }));
};

// ---- Photo upload → base64 ----
// const handleStagePhotoUpload = (stageIdx, files) => {
//   if (!files || files.length === 0) return;

//   Array.from(files).forEach((file) => {
//     // Optional size guard: 3MB
//     if (file.size > 3 * 1024 * 1024) {
//       alert(`⚠️ "${file.name}" exceeds 3MB. Skipped.`);
//       return;
//     }

//     const reader = new FileReader();
//     reader.onloadend = () => {
//       setMaintainForm((prev) => ({
//         ...prev,
//         stages: prev.stages.map((s, i) =>
//           i === stageIdx
//             ? {
//                 ...s,
//                 photos: [
//                   ...s.photos,
//                   { dataUrl: reader.result, name: file.name },
//                 ],
//               }
//             : s
//         ),
//       }));
//     };
//     reader.readAsDataURL(file);
//   });
// };


const handleStagePhotoUpload = (stageIdx, files) => {
  if (!files || files.length === 0) return;

  const selectedFiles = Array.from(files);

  const validFiles = selectedFiles.filter((file) => {
    // 10MB maximum per image
    if (file.size > 10 * 1024 * 1024) {
      alert(`⚠️ "${file.name}" exceeds 10MB. Skipped.`);
      return false;
    }

    // Image validation
    if (!file.type.startsWith("image/")) {
      alert(`⚠️ "${file.name}" is not an image. Skipped.`);
      return false;
    }

    return true;
  });

  if (validFiles.length === 0) return;

  setMaintainForm((prev) => ({
    ...prev,
    stages: prev.stages.map((stage, i) =>
      i === stageIdx
        ? {
            ...stage,
            photos: [
              ...(stage.photos || []),
              ...validFiles.map((file) => ({
                file,
                name: file.name,
                dataUrl: URL.createObjectURL(file),
                isNew: true,
              })),
            ],
          }
        : stage
    ),
  }));
};






// const removeStagePhoto = (stageIdx, photoIdx) => {
//   setMaintainForm((prev) => ({
//     ...prev,
//     stages: prev.stages.map((s, i) =>
//       i === stageIdx
//         ? { ...s, photos: s.photos.filter((_, p) => p !== photoIdx) }
//         : s
//     ),
//   }));
// };




const removeStagePhoto = (stageIdx, photoIdx) => {
  setMaintainForm((prev) => ({
    ...prev,
    stages: prev.stages.map((stage, i) => {
      if (i !== stageIdx) return stage;

      const photoToRemove = stage.photos?.[photoIdx];

      // Release browser object URL for newly selected files
      if (photoToRemove?.isNew && photoToRemove?.dataUrl) {
        URL.revokeObjectURL(photoToRemove.dataUrl);
      }

      return {
        ...stage,
        photos: stage.photos.filter(
          (_, p) => p !== photoIdx
        ),
      };
    }),
  }));
};







const uploadStagePhoto = async (
  file,
  patientId,
  profileId,
  stageIndex
) => {
  if (!file) return null;

  const timestamp = Date.now();

  const safeFileName = file.name.replace(
    /[^a-zA-Z0-9.-]/g,
    "_"
  );

  const storagePath =
    `recovery-profile/${patientId}/follow-ups/stage-${stageIndex + 1}/${timestamp}_${safeFileName}`;

  const storageRef = ref(storage, storagePath);

  await uploadBytes(storageRef, file);

  const downloadURL = await getDownloadURL(storageRef);

  return {
    url: downloadURL,
    name: file.name,
    storagePath,
  };
};








// const saveMaintainReport = async () => {
//   try {
//     setSavingMaintain(true);

//     // Normalize main height and weight
//     const heightValue = maintainForm.height
//       ? `${parseFloat(maintainForm.height)} cm`
//       : "";

//     const weightValue = maintainForm.weight
//       ? `${parseFloat(maintainForm.weight)} kg`
//       : "";

//     // Normalize stage follow-up height and weight
//     const normalizedStages = maintainForm.stages.map((stage) => ({
//       ...stage,

//       followupheight: stage.followupheight
//         ? `${parseFloat(stage.followupheight)} cm`
//         : "",

//       followupweight: stage.followupweight
//         ? `${parseFloat(stage.followupweight)} kg`
//         : "",
//     }));

//     const profileRef = doc(
//       db,
//       "recovery-profile",
//       maintainModal.profile.id
//     );

//     await updateDoc(profileRef, {
//       recoveryStartDate: maintainForm.recoveryStartDate,

//       // Main recovery values
//       height: heightValue,
//       weight: weightValue,

//       condition: maintainForm.condition,
//       assignedConsultant: maintainForm.assignedConsultant,
//       menarche: maintainForm.menarche,
//       treatmentPlan: maintainForm.treatmentPlan,
//       remarks: maintainForm.remarks,

//       // Stages with normalized cm / kg
//       stages: normalizedStages,

//       updatedAt: serverTimestamp(),
//     });

//     // Update local list
//     setVrpProfiles((prev) =>
//       prev.map((p) =>
//         p.id === maintainModal.profile.id
//           ? {
//               ...p,
//               ...maintainForm,
//               height: heightValue,
//               weight: weightValue,
//               stages: normalizedStages,
//               updatedAt: new Date(),
//             }
//           : p
//       )
//     );

//     alert("✅ Recovery report updated successfully!");

//     setMaintainModal({
//       open: false,
//       profile: null,
//     });

//   } catch (err) {
//     console.error("Error saving maintain report:", err);
//     alert("❌ Failed to save: " + err.message);
//   } finally {
//     setSavingMaintain(false);
//   }
// };


const saveMaintainReport = async () => {
  try {
    setSavingMaintain(true);

    const patientId =
      maintainModal.profile.patientId;

    const profileId =
      maintainModal.profile.id;

    // ==========================================
    // NORMALIZE MAIN HEIGHT / WEIGHT
    // ==========================================

    const heightNumber = parseFloat(
      maintainForm.height
    );

    const weightNumber = parseFloat(
      maintainForm.weight
    );

    const heightValue =
      maintainForm.height &&
      !isNaN(heightNumber)
        ? `${heightNumber} cm`
        : "";

    const weightValue =
      maintainForm.weight &&
      !isNaN(weightNumber)
        ? `${weightNumber} kg`
        : "";

    // ==========================================
    // UPLOAD STAGE PHOTOS
    // ==========================================

    const normalizedStages = [];

    for (
      let stageIndex = 0;
      stageIndex < maintainForm.stages.length;
      stageIndex++
    ) {
      const stage = maintainForm.stages[stageIndex];

      const existingPhotos = [];
      const newPhotos = [];

      // Separate existing Storage URLs
      // from newly selected File objects
      for (const photo of stage.photos || []) {
        if (photo.isNew && photo.file) {
          newPhotos.push(photo);
        } else if (photo.url) {
          existingPhotos.push({
            url: photo.url,
            name: photo.name || "",
            storagePath: photo.storagePath || "",
          });
        } else if (photo.dataUrl && !photo.file) {
          // Backward compatibility for old Base64 photos
          existingPhotos.push({
            url: photo.dataUrl,
            name: photo.name || "",
            storagePath: "",
          });
        }
      }

      // Upload newly selected photos
      for (const photo of newPhotos) {
        const uploadedPhoto = await uploadStagePhoto(
          photo.file,
          patientId,
          profileId,
          stageIndex
        );

        if (uploadedPhoto) {
          existingPhotos.push(uploadedPhoto);
        }
      }

      // Normalize stage height
      const stageHeightNumber = parseFloat(
        stage.followupheight
      );

      const normalizedHeight =
        stage.followupheight &&
        !isNaN(stageHeightNumber)
          ? `${stageHeightNumber} cm`
          : "";

      // Normalize stage weight
      const stageWeightNumber = parseFloat(
        stage.followupweight
      );

      const normalizedWeight =
        stage.followupweight &&
        !isNaN(stageWeightNumber)
          ? `${stageWeightNumber} kg`
          : "";

      normalizedStages.push({
        ...stage,

        followupheight: normalizedHeight,
        followupweight: normalizedWeight,

        // IMPORTANT:
        // Firestore now receives Storage URLs,
        // not File objects or Base64.
        photos: existingPhotos,
      });
    }

    // ==========================================
    // FIRESTORE UPDATE
    // ==========================================

    const profileRef = doc(
      db,
      "recovery-profile",
      profileId
    );

    await updateDoc(profileRef, {
      recoveryStartDate:
        maintainForm.recoveryStartDate,

      height: heightValue,
      weight: weightValue,

      condition: maintainForm.condition,
      assignedConsultant:
        maintainForm.assignedConsultant,
      menarche: maintainForm.menarche,
      treatmentPlan: maintainForm.treatmentPlan,
      remarks: maintainForm.remarks,

      stages: normalizedStages,

      updatedAt: serverTimestamp(),
    });

    // ==========================================
    // UPDATE LOCAL STATE
    // ==========================================

    setVrpProfiles((prev) =>
      prev.map((p) =>
        p.id === profileId
          ? {
              ...p,
              recoveryStartDate:
                maintainForm.recoveryStartDate,

              height: heightValue,
              weight: weightValue,

              condition:
                maintainForm.condition,

              assignedConsultant:
                maintainForm.assignedConsultant,

              menarche:
                maintainForm.menarche,

              treatmentPlan:
                maintainForm.treatmentPlan,

              remarks:
                maintainForm.remarks,

              stages: normalizedStages,

              updatedAt: new Date(),
            }
          : p
      )
    );

    alert(
      "✅ Recovery report updated successfully!"
    );

    setMaintainModal({
      open: false,
      profile: null,
    });

  } catch (err) {
    console.error(
      "Error saving maintain report:",
      err
    );

    alert(
      "❌ Failed to save: " +
        err.message
    );
  } finally {
    setSavingMaintain(false);
  }
};






// ============================================================
// VIEW MODAL
// ============================================================
const openViewModal = (profile) => {
  setViewModal({ open: true, profile });
};

// ============================================================
// DELETE MODAL
// ============================================================
const openDeleteModalRecovery = (profile) => {
  setDeleteModal({ open: true, profile });
  setVrpAuthCode("");
  setVrpAuthError("");
};

const confirmDeleteProfile = async () => {
  if (vrpAuthCode !== AUTH_CODE) {
    setVrpAuthError("❌ Invalid authorisation code.");
    return;
  }
  try {
    await deleteDoc(doc(db, "recovery-profile", deleteModalRecovery.profile.id));
    setVrpProfiles((prev) => prev.filter((p) => p.id !== deleteModalRecovery.profile.id));
    alert("✅ Recovery profile deleted successfully!");
    setDeleteModalRecovery({ open: false, profile: null });
    setVrpAuthCode("");
    setVrpAuthError("");
  } catch (err) {
    console.error("Error deleting profile:", err);
    alert("❌ Failed to delete: " + err.message);
  }
};













///////////////////////////////////////send follow up reminder  ///////////////////////////////////////

// ============ FOLLOW-UP STATE ============
const [followUpProfiles, setFollowUpProfiles]   = useState([]);
const [dueOrOverdue, setDueOrOverdue]           = useState([]);
const [upcomingFollowUps, setUpcomingFollowUps] = useState([]);
const [followUpLoading, setFollowUpLoading]     = useState(false);
const [followUpError, setFollowUpError]         = useState('');
const [showFollowUpModal, setShowFollowUpModal] = useState(false);
const [selectedFollowUp, setSelectedFollowUp]   = useState(null); // { patient, stage }
const [followUpLanguage, setFollowUpLanguage]   = useState('english');
const [englishFollowUpMsg, setEnglishFollowUpMsg] = useState('');
const [sinhalaFollowUpMsg, setSinhalaFollowUpMsg] = useState('');



// ---------- Helpers ----------
const toDate = (value) => {
  if (!value) return null;
  if (typeof value?.toDate === 'function') return value.toDate();
  if (typeof value === 'object' && 'seconds' in value) return new Date(value.seconds * 1000);
  // handle "2026-9-20" style
  if (typeof value === 'string' && /^\d{4}-\d{1,2}-\d{1,2}$/.test(value)) {
    const [y, m, d] = value.split('-');
    const dt = new Date(`${y}-${m.padStart(2, '0')}-${d.padStart(2, '0')}`);
    return isNaN(dt.getTime()) ? null : dt;
  }
  const dt = new Date(value);
  return isNaN(dt.getTime()) ? null : dt;
};

const getDaysUntil = (dateStr) => {
  const target = toDate(dateStr);
  if (!target) return 999;
  const today = new Date();
  today.setHours(0, 0, 0, 0);
  target.setHours(0, 0, 0, 0);
  return Math.round((target - today) / (1000 * 60 * 60 * 24));
};

const getBadgeClass = (days) => {
  if (days < 0) return 'badge-red';
  if (days === 0) return 'badge-orange';
  if (days <= 3) return 'badge-yellow';
  return 'badge-green';
};

const getDaysUntilLabel = (dateStr) => {
  const d = getDaysUntil(dateStr);
  if (d < 0) return `Overdue by ${Math.abs(d)} day(s)`;
  if (d === 0) return 'Due Today';
  return `In ${d} day(s)`;
};

const formatFollowUpDate = (dateStr) => {
  const d = toDate(dateStr);
  if (!d) return '—';
  return d.toLocaleDateString('en-GB', {
    day: '2-digit',
    month: 'long',
    year: 'numeric',
  });
};

// Read the follow-up date from a stage — handles BOTH spellings
const getStageNextDate = (stage) => {
  if (!stage) return null;
  return stage.nextFollowUpDate || stage.nextfollowUpDate || null;
};







// ---------- Fetch recovery profiles ----------
const fetchFollowUpPatients = async () => {
  setFollowUpLoading(true);
  setFollowUpError('');
  try {
    const snapshot = await getDocs(collection(db, 'recovery-profile'));
    console.log('docs fetched:', snapshot.size);

    const profiles = snapshot.docs.map(doc => ({ id: doc.id, ...doc.data() }));
    setFollowUpProfiles(profiles);

    // Flatten stages -> [{ patient, stage }]
    const flat = [];
    profiles.forEach(p => {
      (p.stages || []).forEach((stage, idx) => {
        const nextDate = getStageNextDate(stage);
        console.log(
          '   → stage:', stage.stageName || `#${idx}`,
          '| raw nextfollowUpDate =', stage.nextfollowUpDate,
          '| resolved =', nextDate,
          '| daysUntil =', getDaysUntil(nextDate)
        );
        if (nextDate) flat.push({ patient: p, stage });
      });
    });
    console.log('🧮 flattened stages:', flat.length);

    // Due today or overdue
    const due = flat.filter(({ stage }) =>
      getDaysUntil(getStageNextDate(stage)) <= 0
    );

    // Upcoming within 30 days
    const upcoming = flat
      .filter(({ stage }) => {
        const d = getDaysUntil(getStageNextDate(stage));
        return d > 0 && d <= 30;
      })
      .sort((a, b) =>
        getDaysUntil(getStageNextDate(a.stage)) -
        getDaysUntil(getStageNextDate(b.stage))
      );

    console.log('✅ due:', due.length, '| upcoming:', upcoming.length);

    setDueOrOverdue(due);
    setUpcomingFollowUps(upcoming);
  } catch (err) {
    console.error('❌ fetch error:', err);
    setFollowUpError('Failed to load follow-ups: ' + err.message);
  } finally {
    setFollowUpLoading(false);
  }
};

// Load on mount
useEffect(() => {
  fetchFollowUpPatients();
}, []);





const openFollowUpModal = (patient, stage, language) => {
  setSelectedFollowUp({ patient, stage });
  setFollowUpLanguage(language);

  const nextDate = getStageNextDate(stage);
  const dateStr  = formatFollowUpDate(nextDate);
  const consultant = patient.assignedConsultant || 'your consultant';

  setEnglishFollowUpMsg(
`Dear ${patient.patientName},

This is a friendly reminder from Southern Rehab Care.
Your next follow-up is scheduled on ${dateStr}.
Please contact us if you need to reschedule.

Thank you,
Southern Rehab Care
Galle`
  );

  setSinhalaFollowUpMsg(
`හිතවත් ${patient.patientName},

Southern Rehab Care වෙතින් මතක් කිරීමක්.

ඔබගේ ඊළඟ නැවත පරීක්ෂණය ${dateStr} දිනට නියමිතය.
දිනය වෙනස් කිරීමට අවශ්‍ය නම් අප හා සම්බන්ධ වන්න.

ස්තූතියි,
Southern Rehab Care
Galle`
  );

  setShowFollowUpModal(true);
};






// ---------- Send via WhatsApp ----------
const sendFollowUpWhatsApp = (patient, language) => {
  const phone = (patient.patientPhone || '').replace(/\D/g, '');
  if (!phone) { alert('❌ No phone number available for this patient'); return; }
  const intlPhone = phone.startsWith('0') ? '94' + phone.substring(1) : phone;
  const message = language === 'english' ? englishFollowUpMsg : sinhalaFollowUpMsg;
  window.open(`https://wa.me/${intlPhone}?text=${encodeURIComponent(message)}`, '_blank');
};

// ---------- Send via SMS ----------
const sendFollowUpSMS = (patient, language) => {
  const phone = (patient.patientPhone || '').replace(/\D/g, '');
  if (!phone) { alert('❌ No phone number available for this patient'); return; }
  const message = language === 'english' ? englishFollowUpMsg : sinhalaFollowUpMsg;
  window.location.href = `sms:${phone}?body=${encodeURIComponent(message)}`;
};

// ---------- Native Call ----------
const callPatient = (patient) => {
  const phone = (patient.patientPhone || '').replace(/\D/g, '');
  if (!phone) { alert('❌ No phone number available'); return; }
  window.location.href = `tel:${phone}`;
};










  return (
    <>
      {/* TOP NAVIGATION BAR */}
      <nav className="top-nav" ref={dropdownRef}>
        <div className="logo">Powered By Glaxmore IT</div>

        <ul className="nav-links">
          {/* Dashboard - Single Button */}
          <li
            className={`nav-single-btn ${selectedOption === "dashboard" ? "active-nav" : ""}`}
            onClick={() => handleSelect("dashboard")}
          >
            <span className="dropdown-label">📊 Dashboard</span>
          </li>

          {/* User Account Dropdown */}
          <li
            className={`dropdown ${openMenu === "userAccount" ? "active-dropdown" : ""}`}
            onClick={(e) => {
              e.stopPropagation();
              toggleDropdown("userAccount");
            }}
          >
            <span className="dropdown-label">User Account ▾</span>
            {openMenu === "userAccount" && (
              <div className="dropdown-menu" onClick={(e) => e.stopPropagation()}>
                <p
                  className={selectedOption === "createUserAccount" ? "active" : ""}
                  onClick={() => handleSelect("createUserAccount")}
                >
                  Create User Account
                </p>
                <p
                  className={selectedOption === "manageUserAccount" ? "active" : ""}
                  onClick={() => handleSelect("manageUserAccount")}
                >
                  Manage User Accounts
                </p>
              </div>
            )}
          </li>

          {/* Patient Dropdown */}
          <li
            className={`dropdown ${openMenu === "patient" ? "active-dropdown" : ""}`}
            onClick={(e) => {
              e.stopPropagation();
              toggleDropdown("patient");
            }}
          >
            <span className="dropdown-label">Patient ▾</span>
            {openMenu === "patient" && (
              <div className="dropdown-menu" onClick={(e) => e.stopPropagation()}>
                <p
                  className={selectedOption === "createRecoveryProfile" ? "active" : ""}
                  onClick={() => handleSelect("createRecoveryProfile")}
                >
                  Create Recovery Profile
                </p>
                <p
                  className={selectedOption === "viewRecoveryProfile" ? "active" : ""}
                  onClick={() => handleSelect("viewRecoveryProfile")}
                >
                  View All Recovery Profile
                </p>
                <p
                  className={selectedOption === "createPatient" ? "active" : ""}
                  onClick={() => handleSelect("createPatient")}
                >
                  Create Patient
                </p>
                <p
                  className={selectedOption === "managePatient" ? "active" : ""}
                  onClick={() => handleSelect("managePatient")}
                >
                  Manage Patients
                </p>
              </div>
            )}
          </li>

          {/* Consultant Dropdown */}
          <li
            className={`dropdown ${openMenu === "consultant" ? "active-dropdown" : ""}`}
            onClick={(e) => {
              e.stopPropagation();
              toggleDropdown("consultant");
            }}
          >
            <span className="dropdown-label">Consultant ▾</span>
            {openMenu === "consultant" && (
              <div className="dropdown-menu" onClick={(e) => e.stopPropagation()}>
                <p
                  className={selectedOption === "createConsultant" ? "active" : ""}
                  onClick={() => handleSelect("createConsultant")}
                >
                  Create Consultant
                </p>
                <p
                  className={selectedOption === "manageConsultant" ? "active" : ""}
                  onClick={() => handleSelect("manageConsultant")}
                >
                  Manage Consultants
                </p>
              </div>
            )}
          </li>

          {/* Send Message Dropdown */}
          <li
            className={`dropdown ${openMenu === "sendMessage" ? "active-dropdown" : ""}`}
            onClick={(e) => {
              e.stopPropagation();
              toggleDropdown("sendMessage");
            }}
          >
            <span className="dropdown-label">Send Message ▾</span>
            {openMenu === "sendMessage" && (
              <div className="dropdown-menu" onClick={(e) => e.stopPropagation()}>
                <p
                  className={selectedOption === "followupReminder" ? "active" : ""}
                  onClick={() => handleSelect("followupReminder")}
                >
                  Follow-Up Reminder
                </p>
                <p
                  className={selectedOption === "birthdayMessage" ? "active" : ""}
                  onClick={() => handleSelect("birthdayMessage")}
                >
                  Birthday Message
                </p>
              </div>
            )}
          </li>

          {/* Logout */}
          <li
            className={`logout-btn ${isLoggingOut ? 'logging-out' : ''}`}
            onClick={(e) => {
              e.stopPropagation();
              handleLogout();
            }}
          >
            {isLoggingOut ? 'Logging out...' : 'Logout'}
          </li>
        </ul>
      </nav>

      {/* PAGE BODY */}
      <div className="page-body">



{/***************************** follow up Reminder ********************************************/}


{selectedOption === "followupReminder" && (
  <div className="follow-up-reminder-wrapper">
    <div className="follow-up-reminder-header">
      <h2>📋 Follow-up Reminders</h2>
      <button
        className="btn-refresh-dash"
        onClick={fetchFollowUpPatients}
        disabled={followUpLoading}
      >
        {followUpLoading ? '⏳ Loading...' : '🔄 Refresh'}
      </button>
    </div>

    {followUpError && (
      <div className="error-message"><span>❌</span> {followUpError}</div>
    )}

    {/* TODAY / OVERDUE */}
    <div className="birthday-section">
      <h3>🔔 Due Today & Overdue ({dueOrOverdue.length})</h3>

      {followUpLoading ? (
        <div className="loading">
          <span className="spinner-dark"></span> Loading follow-ups...
        </div>
      ) : dueOrOverdue.length === 0 ? (
        <div className="empty-state">
          <span>✅</span>
          <p>No follow-ups due today</p>
          <small>All patients are up to date!</small>
        </div>
      ) : (
        <div className="birthday-list">
          {dueOrOverdue.map(({ patient, stage }, idx) => {
            const nextDate = getStageNextDate(stage);
            return (
              <div key={patient.id + (stage.stageName || idx)} className="birthday-card">
                <div className="birthday-patient-info">
                  <div className="birthday-avatar">
                    {patient.patientName?.charAt(0)?.toUpperCase() || '?'}
                  </div>
                  <div>
                    <h4>{patient.patientName}</h4>
                    <p>📞 {patient.patientPhone || '-'}</p>
                  
                    <p>
                      📅 Next Follow-up: {formatFollowUpDate(nextDate)}
                      {" — "}
                      <span className={`days-badge ${getBadgeClass(getDaysUntil(nextDate))}`}>
                        {getDaysUntilLabel(nextDate)}
                      </span>
                    </p>
                    <p>👨‍⚕️ {patient.assignedConsultant || '-'}</p>
                  </div>
                </div>

                <div className="birthday-actions">
                  <button className="btn-preview-en" onClick={() => openFollowUpModal(patient, stage, 'english')}>
                    🇬🇧 English
                  </button>
                  <button className="btn-preview-si" onClick={() => openFollowUpModal(patient, stage, 'sinhala')}>
                    🇱🇰 සිංහල
                  </button>
                </div>
              </div>
            );
          })}
        </div>
      )}
    </div>

    {/* UPCOMING */}
    <div className="birthday-section">
      <h3>📅 Upcoming Follow-ups — {upcomingFollowUps.length}</h3>

      {upcomingFollowUps.length === 0 ? (
        <p className="empty-text">No upcoming follow-ups</p>
      ) : (
        <div className="table-wrapper">
          <table>
            <thead>
              <tr>
                <th>#</th><th>Name</th><th>Phone</th><th>Stage</th>
                <th>Next Follow-up</th><th>Days Left</th><th>Action</th>
              </tr>
            </thead>
            <tbody>
              {upcomingFollowUps.map(({ patient, stage }, index) => {
                const nextDate = getStageNextDate(stage);
                return (
                  <tr key={patient.id + (stage.stageName || index)}>
                    <td>{index + 1}</td>
                    <td>{patient.patientName}</td>
                    <td>{patient.patientPhone || '-'}</td>
                    <td>{formatFollowUpDate(nextDate)}</td>
                    <td>
                      <span className={`days-badge ${getBadgeClass(getDaysUntil(nextDate))}`}>
                        {getDaysUntil(nextDate)} days
                      </span>
                    </td>
                    <td>
                      <button className="btn-edit" onClick={() => openFollowUpModal(patient, stage, 'english')}>
                        ✉️ Send
                      </button>
                    </td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        </div>
      )}
    </div>

    {/* MODAL */}
    {showFollowUpModal && selectedFollowUp && (
      <div
        className="modal-overlay"
        onClick={(e) => {
          if (e.target === e.currentTarget) {
            setShowFollowUpModal(false);
            setSelectedFollowUp(null);
          }
        }}
      >
        <div className="modal-content birthday-modal">
          <div className="modal-header">
            <h3>
              📋 Follow-up Reminder — {selectedFollowUp.patient.patientName}{" "}
              ({selectedFollowUp.stage.stageName || 'N/A'})
            </h3>
            <button className="modal-close" onClick={() => { setShowFollowUpModal(false); setSelectedFollowUp(null); }}>
              ×
            </button>
          </div>

          <div className="lang-tabs">
            <button
              className={`lang-tab ${followUpLanguage === 'english' ? 'active' : ''}`}
              onClick={() => setFollowUpLanguage('english')}
            >🇬🇧 English</button>
            <button
              className={`lang-tab ${followUpLanguage === 'sinhala' ? 'active' : ''}`}
              onClick={() => setFollowUpLanguage('sinhala')}
            >🇱🇰 සිංහල</button>
          </div>

          <div className="message-preview">
            <label>Message Preview:</label>
            <textarea
              className="birthday-textarea"
              value={followUpLanguage === 'english' ? englishFollowUpMsg : sinhalaFollowUpMsg}
              onChange={(e) => {
                if (followUpLanguage === 'english') setEnglishFollowUpMsg(e.target.value);
                else setSinhalaFollowUpMsg(e.target.value);
              }}
              rows="8"
            />
          </div>

          <div className="send-options">
            <h4>Send via:</h4>
            <div className="send-buttons">
              <button className="btn-whatsapp" onClick={() => sendFollowUpWhatsApp(selectedFollowUp.patient, followUpLanguage)}>
                💬 WhatsApp
              </button>
              <button className="btn-sms" onClick={() => sendFollowUpSMS(selectedFollowUp.patient, followUpLanguage)}>
                📱 SMS
              </button>
              <button className="btn-call" onClick={() => callPatient(selectedFollowUp.patient)}>
                📞 Call
              </button>
              <button
                className="btn-copy"
                onClick={() => {
                  const text = followUpLanguage === 'english' ? englishFollowUpMsg : sinhalaFollowUpMsg;
                  navigator.clipboard.writeText(text);
                  alert('✅ Message copied to clipboard!');
                }}
              >
                📋 Copy
              </button>
            </div>
          </div>

          <div className="form-actions">
            <button
              type="button"
              className="btn-cancel"
              onClick={() => { setShowFollowUpModal(false); setSelectedFollowUp(null); }}
            >
              Close
            </button>
          </div>
        </div>
      </div>
    )}
  </div>
)}

{/***************************** view recovery Profiles********************************************/}


{selectedOption === "viewRecoveryProfile" && (
  <div className="View-Recovery-Profile-wrapper">
    <h1 className="View-Recovery-Profile-title">📋 View Recovery Profile</h1>

    {/* Search + Refresh */}
    <div className="vrp-toolbar">
      <input
        type="text"
        className="vrp-search-input"
        placeholder="🔍 Search by patient name, phone, stage, or consultant..."
        value={vrpSearch}
        onChange={(e) => setVrpSearch(e.target.value)}
      />
      <button className="vrp-refresh-btn" onClick={fetchRecoveryProfiles}>
        🔄 Refresh
      </button>
    </div>

    {/* Stats */}
    <div className="vrp-stats">
      Total Profiles: <strong>{vrpProfiles.length}</strong>
    </div>

    {/* Loading / Error */}
    {vrpLoading && <p className="vrp-loading">Loading recovery profiles...</p>}
    {vrpError && <p className="vrp-error">⚠️ {vrpError}</p>}

    {/* Table */}
    {!vrpLoading && !vrpError && (
      <div className="vrp-table-wrapper">
        <table className="vrp-table">
          <thead>
            <tr>
              <th>#</th>
              <th>Patient</th>
              <th>Phone</th>
              <th>DOB</th>
              <th>Condition</th>
              <th>Follow-Up Start Date</th>
              <th>Consultant</th>
              <th>Actions</th>
            </tr>
          </thead>
          <tbody>
            {vrpFiltered.length === 0 ? (
              <tr>
                <td colSpan="9" className="vrp-empty">
                  <span style={{ fontSize: "38px" }}>📭</span>
                  <p>No recovery profiles found</p>
                </td>
              </tr>
            ) : (
              vrpFiltered.map((profile, index) => (
                <tr key={profile.id}>
                  <td>{index + 1}</td>
                  <td><strong>{profile.patientName || "—"}</strong></td>
                  <td>{profile.patientPhone || "—"}</td>
                  <td>{profile.patientDob || "—"}</td>
                  <td>{profile.condition || "—"}</td>
                  <td>{profile.recoveryStartDate || "—"}</td>
                     
                  <td>{profile.assignedConsultant || "—"}</td>
                  <td>
                    <div className="vrp-action-buttons">
                      <button
                        className="vrp-btn vrp-btn-green"
                        onClick={() => openMaintainModal(profile)}
                        title="Maintain Report"
                      >
                        📝 Maintain
                      </button>
                      <button
                        className="vrp-btn vrp-btn-view"
                        onClick={() => openViewModal(profile)}
                        title="View Profile"
                      >
                        👁️ View
                      </button>
                      <button
                        className="vrp-btn vrp-btn-delete"
                        onClick={() => openDeleteModalRecovery(profile)}
                        title="Delete Profile"
                      >
                        🗑️ Delete
                      </button>
                    </div>
                  </td>
                </tr>
              ))
            )}
          </tbody>
        </table>
      </div>
    )}

    {/* ================= MAINTAIN REPORT MODAL ================= */}
    {maintainModal.open && maintainModal.profile && (
      <div className="vrp-modal-overlay">
        <div className="vrp-modal-content vrp-modal-xl">
          <div className="vrp-modal-header vrp-header-green">
            <h3>📝 Maintain Recovery Report</h3>
            <button
              className="vrp-modal-close"
              onClick={() => setMaintainModal({ open: false, profile: null })}
            >
              ×
            </button>
          </div>

          <div className="vrp-modal-body">
            {/* Patient Header */}
            <div className="vrp-patient-header">
              <div>
                <strong>{maintainModal.profile.patientName}</strong>
                <span className="vrp-patient-sub">
                  {maintainModal.profile.patientPhone} • {maintainModal.profile.patientGender}
                </span>
              </div>
              <span className="vrp-badge-consultant">
                👨‍⚕️ {maintainModal.profile.assignedConsultant || "Unassigned"}
              </span>
            </div>

            {/* Editable Fields Section */}
            <div className="vrp-section">
              <h4 className="vrp-section-title">🔧 Editable Recovery Details</h4>
              <div className="vrp-grid-2">
                <div className="vrp-form-group">
                  <label>Follow-Up Start Date</label>
                  <input
                    type="date"
                    className="vrp-input"
                    value={maintainForm.recoveryStartDate}
                    onChange={(e) =>
                      setMaintainForm({ ...maintainForm, recoveryStartDate: e.target.value })
                    }
                  />
                </div>

                <div className="vrp-form-group">
                  <label>Height</label>
                  <input
                    type="text"
                    className="vrp-input"
                    value={maintainForm.height}
                    onChange={(e) =>
                      setMaintainForm({ ...maintainForm, height: e.target.value })
                    }
                  />
                </div>


                <div className="vrp-form-group">
                  <label>Condition / Diagnosis</label>
                  <input
                    type="text"
                    className="vrp-input"
                    value={maintainForm.condition}
                    onChange={(e) =>
                      setMaintainForm({ ...maintainForm, condition: e.target.value })
                    }
                  />
                </div>


                <div className="vrp-form-group">
                  <label>Weight</label>
                   <input
                    type="text"
                    className="vrp-input"
                    value={maintainForm.weight}
                    onChange={(e) =>
                      setMaintainForm({ ...maintainForm, weight: e.target.value })
                    }
                  />
                </div>


                <div className="vrp-form-group">
                  <label>Assigned Consultant</label>
                  <select
                    className="vrp-input"
                    value={maintainForm.assignedConsultant}
                    onChange={(e) =>
                      setMaintainForm({ ...maintainForm, assignedConsultant: e.target.value })
                    }
                  >
                    <option value="">Select Consultant</option>
                    {consultants.map((c) => (
                      <option key={c.id} value={c.name}>
                        {c.name}
                        {c.specialization ? ` — ${c.specialization}` : ""}
                      </option>
                    ))}
                  </select>
                </div>
                <div className="vrp-form-group">
                  <label>Menarche</label>
                  <input
                    type="date"
                    className="vrp-input"
                    value={maintainForm.menarche}
                    onChange={(e) =>
                      setMaintainForm({ ...maintainForm, menarche: e.target.value })
                    }
                  />
                </div>
                <div className="vrp-form-group vrp-full-width">
                  <label>Treatment Plan / Notes</label>
                  <textarea
                    className="vrp-input vrp-textarea"
                    rows="3"
                    value={maintainForm.treatmentPlan}
                    onChange={(e) =>
                      setMaintainForm({ ...maintainForm, treatmentPlan: e.target.value })
                    }
                  />
                </div>
                <div className="vrp-form-group vrp-full-width">
                  <label>Additional Remarks</label>
                  <textarea
                    className="vrp-input vrp-textarea"
                    rows="2"
                    value={maintainForm.remarks}
                    onChange={(e) =>
                      setMaintainForm({ ...maintainForm, remarks: e.target.value })
                    }
                  />
                </div>





                  {/* ================= INITIAL PHOTOS ================= */}
                  <div className="vrp-section">
                    <h4 className="vrp-section-title">
                      📸 Initial Recovery Photos
                    </h4>

                    <div className="vrp-initial-photo-grid">

                      {/* X-Ray Photo */}
                      <div className="vrp-initial-photo-card">
                        <h5>🩻 X-Ray Photo</h5>

                        {maintainForm.xrayPhoto ? (
                          <div className="vrp-initial-photo-preview">
                            <img
                              src={maintainForm.xrayPhoto}
                              alt="Patient X-Ray"
                              onClick={() =>
                                window.open(maintainForm.xrayPhoto, "_blank")
                              }
                            />

                            <a
                              href={maintainForm.xrayPhoto}
                              target="_blank"
                              rel="noopener noreferrer"
                              className="vrp-photo-view-link"
                            >
                              🔍 View Full Image
                            </a>
                          </div>
                        ) : (
                          <div className="vrp-no-photo">
                            No X-Ray photo uploaded
                          </div>
                        )}
                      </div>

                      {/* First Day Picture */}
                      <div className="vrp-initial-photo-card">
                        <h5>📷 First Day Picture</h5>

                        {maintainForm.firstDayPicture ? (
                          <div className="vrp-initial-photo-preview">
                            <img
                              src={maintainForm.firstDayPicture}
                              alt="Patient First Day"
                              onClick={() =>
                                window.open(maintainForm.firstDayPicture, "_blank")
                              }
                            />

                            <a
                              href={maintainForm.firstDayPicture}
                              target="_blank"
                              rel="noopener noreferrer"
                              className="vrp-photo-view-link"
                            >
                              🔍 View Full Image
                            </a>
                          </div>
                        ) : (
                          <div className="vrp-no-photo">
                            No First Day picture uploaded
                          </div>
                        )}
                      </div>

                    </div>
                  </div>


              </div>
            </div>






            {/* ============ STAGE-WISE PHOTOS ============ */}
            <div className="vrp-section">
              <h4 className="vrp-section-title">
                📸 Follow-Up Records
                <span className="vrp-badge-count">
                  {maintainForm.stages.length} Follow-Up(s)
                </span>
              </h4>

              <button
                type="button"
                className="vrp-btn-add-stage"
                onClick={addNewStage}
              >
                ➕ Add New Follow-Up Record
              </button>

              {maintainForm.stages.length === 0 ? (
                <p className="vrp-no-stages">
                  No stage records yet. Click "Add New Stage Record" to add photos and follow-up dates.
                </p>
              ) : (
                maintainForm.stages.map((stage, sIdx) => (
                  <div key={sIdx} className="vrp-stage-card">
                    <div className="vrp-stage-card-header">
                      <h5>Follow-Up #{sIdx + 1}</h5>
                      <button
                        type="button"
                        className="vrp-btn-remove-stage"
                        onClick={() => removeStage(sIdx)}
                      >
                        ✖ Remove
                      </button>
                    </div>

                    <div className="vrp-stage-body">
                      <div className="vrp-grid-2">

                        <div className="vrp-form-group">
                          <label>Follow-Up Name *</label>
                          <input
                            type="text"
                            className="vrp-input"
                            placeholder="e.g. A1 B1"
                            value={stage.stageName}
                            onChange={(e) => updateStage(sIdx, "stageName", e.target.value)}
                          />
                        </div>

                        <div className="vrp-form-group">
                          <label>Current Follow-Up Date *</label>
                          <input
                            type="date"
                            className="vrp-input"
                            value={stage.followUpDate}
                            onChange={(e) => updateStage(sIdx, "followUpDate", e.target.value)}
                          />
                        </div>



                        <div className="vrp-form-group">
                          <label>Follow-Up Height</label>
                          <input
                            type="text"
                            className="vrp-input"
                            value={stage.followupheight}
                            onChange={(e) => updateStage(sIdx, "followupheight", e.target.value)}
                          />
                        </div>



                        <div className="vrp-form-group">
                          <label>Follow-Up Weight</label>
                          <input
                            type="text"
                            className="vrp-input"
                            value={stage.followupweight}
                            onChange={(e) => updateStage(sIdx, "followupweight", e.target.value)}
                          />
                        </div>



                        <div className="vrp-form-group">
                          <label>Next Follow-Up Date *</label>
                          <input
                            type="date"
                            className="vrp-input"
                            value={stage.nextfollowUpDate}
                            onChange={(e) => updateStage(sIdx, "nextfollowUpDate", e.target.value)}
                          />
                        </div>


                        <div className="vrp-form-group vrp-full-width">
                          <label>Follow-Up Notes</label>
                          <textarea
                            className="vrp-input vrp-textarea"
                            rows="2"
                            placeholder="Progress notes for this stage..."
                            value={stage.notes}
                            onChange={(e) => updateStage(sIdx, "notes", e.target.value)}
                          />
                        </div>
                      </div>


                        {/* Photo Upload */}
                    <div className="vrp-photo-upload">
                      <label className="vrp-photo-label">
                        📷 Upload Photos for This Follow-Up

                        <input
                          type="file"
                          accept="image/*"
                          multiple
                          className="vrp-file-input"
                          onChange={(e) =>
                            handleStagePhotoUpload(
                              sIdx,
                              e.target.files
                            )
                          }
                        />
                      </label>

                      {stage.photos?.length > 0 && (
                        <div className="vrp-photo-grid">
                          {stage.photos.map((photo, pIdx) => {
                            const imageSource =
                              photo.url || photo.dataUrl;

                            return (
                              <div
                                key={pIdx}
                                className="vrp-photo-item"
                              >
                                <img
                                  src={imageSource}
                                  alt={`Follow-Up ${
                                    sIdx + 1
                                  } photo ${pIdx + 1}`}
                                  onClick={() =>
                                    window.open(
                                      imageSource,
                                      "_blank"
                                    )
                                  }
                                />

                                <div className="vrp-photo-name">
                                  {photo.name ||
                                    `Photo ${pIdx + 1}`}
                                </div>

                                <button
                                  type="button"
                                  className="vrp-photo-remove"
                                  onClick={() =>
                                    removeStagePhoto(
                                      sIdx,
                                      pIdx
                                    )
                                  }
                                >
                                  ✖
                                </button>
                              </div>
                            );
                          })}
                        </div>
                      )}
                    </div>





                    </div>
                  </div>
                ))
              )}
            </div>



          </div>

          <div className="vrp-modal-footer">
            <button
              className="vrp-btn vrp-btn-gray"
              onClick={() => setMaintainModal({ open: false, profile: null })}
              disabled={savingMaintain}
            >
              Cancel
            </button>
            <button
              className="vrp-btn vrp-btn-green"
              onClick={saveMaintainReport}
              disabled={savingMaintain}
            >
              {savingMaintain ? "⏳ Saving..." : "💾 Save Changes"}
            </button>
          </div>
        </div>
      </div>
    )}

    {/* ================= VIEW MODAL ================= */}
    {viewModal.open && viewModal.profile && (
      <div className="vrp-modal-overlay">
        <div className="vrp-modal-content vrp-modal-lg">
          <div className="vrp-modal-header">
            <h3>👁️ Recovery Profile Details</h3>
            <button
              className="vrp-modal-close"
              onClick={() => setViewModal({ open: false, profile: null })}
            >
              ×
            </button>
          </div>
          <div className="vrp-modal-body">
            <div className="vrp-section">
              <h4 className="vrp-section-title">👤 Patient</h4>
              <div className="vrp-view-grid">
                <div><label>Name</label><span>{viewModal.profile.patientName || "—"}</span></div>
                <div><label>Phone</label><span>{viewModal.profile.patientPhone || "—"}</span></div>
                <div><label>Email</label><span>{viewModal.profile.patientEmail || "—"}</span></div>
                <div><label>Gender</label><span>{viewModal.profile.patientGender || "—"}</span></div>
                <div><label>DOB</label><span>{viewModal.profile.patientDob || "—"}</span></div>
                <div className="vrp-full-width"><label>Address</label><span>{viewModal.profile.patientAddress || "—"}</span></div>
              </div>
            </div>

            <div className="vrp-section">
              <h4 className="vrp-section-title"></h4>
              <div className="vrp-view-grid">
                <div><label>Follow-Up Start Date</label><span>{viewModal.profile.recoveryStartDate || "—"}</span></div>
                <div><label>Height</label><span>{viewModal.profile.height || "—"}</span></div>
                <div><label>Weight</label><span>{viewModal.profile.weight || "—"}</span></div>
                <div><label>Condition</label><span>{viewModal.profile.condition || "—"}</span></div>
                <div><label>Menarche</label><span>{viewModal.profile.menarche || "—"}</span></div>
                <div><label>Consultant</label><span>{viewModal.profile.assignedConsultant || "—"}</span></div>
                <div className="vrp-full-width"><label>Treatment Plan</label><span>{viewModal.profile.treatmentPlan || "—"}</span></div>
                <div className="vrp-full-width"><label>Remarks</label><span>{viewModal.profile.remarks || "—"}</span></div>
              </div>
            </div>





{/* ================= INITIAL PHOTOS ================= */}
<div className="vrp-section">
  <h4 className="vrp-section-title">
    📸 Initial Recovery Photos
  </h4>

  <div className="vrp-initial-photo-grid">

    {/* X-Ray Photo */}
    <div className="vrp-initial-photo-card">
      <h5>🩻 X-Ray Photo</h5>

      {viewModal.profile.xrayPhoto ? (
        <div className="vrp-initial-photo-preview">
          <img
            src={viewModal.profile.xrayPhoto}
            alt="Patient X-Ray"
            onClick={() =>
              window.open(
                viewModal.profile.xrayPhoto,
                "_blank"
              )
            }
          />

          <a
            href={viewModal.profile.xrayPhoto}
            target="_blank"
            rel="noopener noreferrer"
            className="vrp-photo-view-link"
          >
            🔍 View Full Image
          </a>
        </div>
      ) : (
        <div className="vrp-no-photo">
          No X-Ray photo available
        </div>
      )}
    </div>

    {/* First Day Picture */}
    <div className="vrp-initial-photo-card">
      <h5>📷 First Day Picture</h5>

      {viewModal.profile.firstDayPicture ? (
        <div className="vrp-initial-photo-preview">
          <img
            src={viewModal.profile.firstDayPicture}
            alt="Patient First Day"
            onClick={() =>
              window.open(
                viewModal.profile.firstDayPicture,
                "_blank"
              )
            }
          />

          <a
            href={viewModal.profile.firstDayPicture}
            target="_blank"
            rel="noopener noreferrer"
            className="vrp-photo-view-link"
          >
            🔍 View Full Image
          </a>
        </div>
      ) : (
        <div className="vrp-no-photo">
          No First Day picture available
        </div>
      )}
    </div>

  </div>
</div>







            <div className="vrp-section">
              <h4 className="vrp-section-title">
                📸 Progress Record ({viewModal.profile.stages?.length || 0})
              </h4>
              {!viewModal.profile.stages || viewModal.profile.stages.length === 0 ? (
                <p className="vrp-no-stages">No stage records available.</p>
              ) : (
                viewModal.profile.stages.map((stage, sIdx) => (
                  <div key={sIdx} className="vrp-stage-view-card">
                    <div className="vrp-stage-view-header">
                      <strong>{stage.stageName || `Stage ${sIdx + 1}`}</strong>

                      
                      <span className="vrp-followup-chip">
                        Follow-up Height: {stage.followupheight || "-"}
                      </span>

                                            <span className="vrp-followup-chip">
                        Follow-up Weight: {stage.followupweight || "-"}
                      </span>

                      <span className="vrp-followup-chip">
                        📅 {stage.followUpDate || "No date"}
                      </span>

                      <span className="vrp-followup-chip">
                        📅 Next Follow-Up Date: {stage.nextfollowUpDate || "No date"}
                      </span>



                    </div>


                    {stage.notes && <p className="vrp-stage-notes">{stage.notes}</p>}



                      {stage.photos?.length > 0 && (
                        <div className="vrp-photo-grid">
                          {stage.photos.map((photo, pIdx) => {
                            const imageSource =
                              photo.url || photo.dataUrl;

                            return (
                              <div
                                key={pIdx}
                                className="vrp-photo-item"
                              >
                                <img
                                  src={imageSource}
                                  alt={`stage-${sIdx + 1}-${pIdx + 1}`}
                                  onClick={() =>
                                    window.open(
                                      imageSource,
                                      "_blank"
                                    )
                                  }
                                />

                                <div className="vrp-photo-name">
                                  {photo.name ||
                                    `Photo ${pIdx + 1}`}
                                </div>
                              </div>
                            );
                          })}
                        </div>
                      )}





                  </div>
                ))
              )}
            </div>
          </div>
          <div className="vrp-modal-footer">
            <button
              className="vrp-btn vrp-btn-gray"
              onClick={() => setViewModal({ open: false, profile: null })}
            >
              Close
            </button>
          </div>
        </div>
      </div>
    )}

    {/* ================= DELETE MODAL ================= */}
    {deleteModal.open && deleteModal.profile && (
      <div className="vrp-modal-overlay">
        <div className="vrp-modal-content">
          <div className="vrp-modal-header vrp-header-red">
            <h3>🗑️ Delete Recovery Profile</h3>
            <button
              className="vrp-modal-close"
              onClick={() => setDeleteModal({ open: false, profile: null })}
            >
              ×
            </button>
          </div>
          <div className="vrp-modal-body">
            <p>Are you sure you want to delete this recovery profile?</p>
            <div className="vrp-delete-info">
              <strong>{deleteModal.profile.patientName}</strong>
              <br />
              <small>{deleteModal.profile.condition}</small>
            </div>
            <p className="vrp-warning-text">⚠️ This action cannot be undone.</p>

            <div className="vrp-form-group" style={{ marginTop: "16px" }}>
              <label>Enter Authorisation Code *</label>
              <input
                type="password"
                className="vrp-input"
                placeholder="Enter authorisation code"
                value={vrpAuthCode}
                onChange={(e) => setVrpAuthCode(e.target.value)}
              />
              {vrpAuthError && <p className="vrp-error-text">{vrpAuthError}</p>}
            </div>
          </div>
          <div className="vrp-modal-footer">
            <button
              className="vrp-btn vrp-btn-gray"
              onClick={() => {
                setDeleteModal({ open: false, profile: null });
                setVrpAuthCode("");
                setVrpAuthError("");
              }}
            >
              Cancel
            </button>
            <button className="vrp-btn vrp-btn-red" onClick={confirmDeleteProfile}>
              Delete
            </button>
          </div>
        </div>
      </div>
    )}
  </div>
)}




{/*********************************** create Recovery Profile *****************************************/}


{selectedOption === "createRecoveryProfile" && (
  <div className="manage-user-wrapper">
    <h1 className="manage-user-title">🩺 Create Recovery Profile</h1>

    {/* ============ SEARCH BAR ============ */}
    <div className="crp-search-section">
      <label className="crp-search-label">Search Patient</label>
      <div className="crp-search-wrapper">
        <input
          type="text"
          className="crp-search-input"
          placeholder="🔍 Search by patient name, phone, or email..."
          value={patientSearch}
          onChange={(e) => {
            setPatientSearch(e.target.value);
            setShowSuggestions(true);
          }}
          onFocus={() => setShowSuggestions(true)}
        />

        {/* Suggestions dropdown */}
        {showSuggestions && patientSearch.length > 0 && (
          <div className="crp-suggestions-dropdown">
            {searchResults.length === 0 ? (
              <div className="crp-suggestion-empty">
                No patients found for "{patientSearch}"
              </div>
            ) : (
              searchResults.map((p) => (
                <div
                  key={p.id}
                  className="crp-suggestion-item"
                  onClick={() => selectPatient(p)}
                >
                  <div className="crp-suggestion-main">
                    <strong>{p.name || "Unnamed"}</strong>
                    <span className="crp-suggestion-phone">
                      {p.telephoneNo || "No phone"}
                    </span>
                  </div>
                  <div className="crp-suggestion-details">
                    <span>{p.email || "No email"}</span>
                    <span>•</span>
                    <span>{p.sex || "—"}</span>
                    <span>•</span>
                    <span>{p.address || "No address"}</span>
                  </div>
                </div>
              ))
            )}
          </div>
        )}
      </div>

      {selectedPatient && (
        <div className="crp-selected-badge">
          ✅ Selected: <strong>{selectedPatient.name}</strong>
          <button
            className="crp-clear-btn"
            onClick={() => {
              setSelectedPatient(null);
              resetForm();
            }}
          >
            ✖ Clear
          </button>
        </div>
      )}
    </div>

    {/* ============ RECOVERY FORM ============ */}
    {selectedPatient ? (
      <div className="crp-form">
        {/* Patient Info (read-only from selected patient) */}
        <div className="crp-section">
          <h3 className="crp-section-title">👤 Patient Information</h3>
          <div className="crp-form-grid">
            <div className="crp-form-group">
              <label>Patient Name</label>
              <input
                type="text"
                className="crp-input crp-input-readonly"
                value={selectedPatient.name || ""}
                readOnly
              />
            </div>
            <div className="crp-form-group">
              <label>Date of Birth</label>
              <input
                type="text"
                className="crp-input crp-input-readonly"
                value={
                  selectedPatient.dateOfBirth
                    ? new Date(selectedPatient.dateOfBirth).toLocaleDateString()
                    : "—"
                }
                readOnly
              />
            </div>
            <div className="crp-form-group">
              <label>Gender</label>
              <input
                type="text"
                className="crp-input crp-input-readonly"
                value={selectedPatient.sex || "—"}
                readOnly
              />
            </div>
            <div className="crp-form-group">
              <label>Phone</label>
              <input
                type="text"
                className="crp-input crp-input-readonly"
                value={selectedPatient.telephoneNo || "—"}
                readOnly
              />
            </div>
            <div className="crp-form-group crp-full-width">
              <label>Address</label>
              <input
                type="text"
                className="crp-input crp-input-readonly"
                value={selectedPatient.address || "—"}
                readOnly
              />
            </div>
          </div>
        </div>





        {/* Recovery Profile Fields */}
        <div className="crp-section">
          <h3 className="crp-section-title">🩺 Follow-Up Details</h3>
          <div className="crp-form-grid">
            <div className="crp-form-group">
              <label>Follow-Up Start Date *</label>
              <input
                type="date"
                className="crp-input"
                value={recoveryForm.recoveryStartDate}
                onChange={(e) =>
                  setRecoveryForm({
                    ...recoveryForm,
                    recoveryStartDate: e.target.value,
                  })
                }
              />
            </div>

            <div className="crp-form-group">
              <label>Height</label>
              <input
                type="text"
                className="crp-input"
                placeholder="e.g. 170 cm"
                value={recoveryForm.height}
                onChange={(e) =>
                  setRecoveryForm({
                    ...recoveryForm,
                    height: e.target.value,
                  })
                }
              />
            </div>

            <div className="crp-form-group">
              <label>Condition / Diagnosis *</label>
              <input
                type="text"
                className="crp-input"
                placeholder="e.g. Post-operative recovery"
                value={recoveryForm.condition}
                onChange={(e) =>
                  setRecoveryForm({
                    ...recoveryForm,
                    condition: e.target.value,
                  })
                }
              />
            </div>

            <div className="crp-form-group">
              <label>Weight</label>
              <input
                type="text"
                className="crp-input"
                placeholder="e.g. 70 kg"
                value={recoveryForm.weight}
                onChange={(e) =>
                  setRecoveryForm({
                    ...recoveryForm,
                    weight: e.target.value,
                  })
                }
              />
            </div>


            <div className="crp-form-group">
              <label>Assigned Consultant *</label>
              <select
                className="crp-input"
                value={recoveryForm.assignedConsultant}
                onChange={(e) =>
                  setRecoveryForm({
                    ...recoveryForm,
                    assignedConsultant: e.target.value,
                  })
                }
              >
                <option value="">Select Consultant</option>

                {consultantsLoading && (
                  <option value="" disabled>Loading consultants...</option>
                )}

                {!consultantsLoading && consultants.length === 0 && (
                  <option value="" disabled>No consultants available</option>
                )}

                {!consultantsLoading &&
                  consultants.map((c) => (
                    <option key={c.id} value={c.name}>
                      {c.name}
                      {c.specialization ? ` — ${c.specialization}` : ""}
                    </option>
                  ))}
              </select>

              {consultantsError && (
                <p className="crp-error-text">{consultantsError}</p>
              )}
            </div>







            <div className="crp-form-group">
              <label>Menarche</label>
                <input
                 type="date"
                className="crp-input"
                value={recoveryForm.menarche}
                onChange={(e) =>
                  setRecoveryForm({
                    ...recoveryForm,
                    menarche: e.target.value,
                  })
                }
              />
            </div>






            <div className="crp-form-group">
              <label>Next Follow-up Date</label>
              <input
                type="date"
                className="crp-input"
                value={recoveryForm.nextFollowUp}
                onChange={(e) =>
                  setRecoveryForm({
                    ...recoveryForm,
                    nextFollowUp: e.target.value,
                  })
                }
              />
            </div>

            <div className="crp-form-group crp-full-width">
              <label>Treatment Plan / Notes</label>
              <textarea
                className="crp-input crp-textarea"
                rows="3"
                placeholder="Enter treatment plan, exercises, medication notes..."
                value={recoveryForm.treatmentPlan}
                onChange={(e) =>
                  setRecoveryForm({
                    ...recoveryForm,
                    treatmentPlan: e.target.value,
                  })
                }
              />
            </div>

            <div className="crp-form-group crp-full-width">
              <label>Additional Remarks</label>
              <textarea
                className="crp-input crp-textarea"
                rows="2"
                placeholder="Any additional remarks..."
                value={recoveryForm.remarks}
                onChange={(e) =>
                  setRecoveryForm({
                    ...recoveryForm,
                    remarks: e.target.value,
                  })
                }
              />
            </div>



            <div className="crp-form-group">
              <label>X-Ray Photo</label>
              <input
                type="file"
                className="crp-input"
                accept="image/*"
                onChange={(e) =>
                  setRecoveryForm({
                    ...recoveryForm,
                    xrayPhoto: e.target.files[0] || null,
                  })
                }
              />
              
              {recoveryForm.xrayPhoto && (
                <small className="crp-file-name">
                  Selected: {recoveryForm.xrayPhoto.name}
                </small>
              )}
            </div>

            <div className="crp-form-group">
              <label>First Day Picture</label>
              <input
                type="file"
                className="crp-input"
                accept="image/*"
                onChange={(e) =>
                  setRecoveryForm({
                    ...recoveryForm,
                    firstDayPicture: e.target.files[0] || null,
                  })
                }
              />

              {recoveryForm.firstDayPicture && (
                <small className="crp-file-name">
                  Selected: {recoveryForm.firstDayPicture.name}
                </small>
              )}
            </div>





          </div>
        </div>







        {/* Actions */}
        <div className="crp-actions">
          <button
            className="crp-btn-cancel"
            onClick={() => {
              setSelectedPatient(null);
              resetForm();
            }}
            disabled={savingRecovery}
          >
            ❌ Cancel
          </button>
          <button
            className="crp-btn-save"
            onClick={saveRecoveryProfile}
            disabled={savingRecovery}
          >
            {savingRecovery ? "⏳ Saving..." : "💾 Save Recovery Profile"}
          </button>
        </div>
      </div>
    ) : (
      <div className="crp-empty-state">
        <span style={{ fontSize: "48px" }}>🔍</span>
        <p>Search and select a patient above to create their recovery profile</p>
      </div>
    )}
  </div>
)}














{/****************************************************** Manage User Account / View all user account  *******************************************************************/}

{selectedOption === "manageUserAccount" && (
  <div className="manage-user-wrapper">
    <h1 className="manage-user-title">Manage User Account</h1>

    {/* Search Bar */}
    <div className="manage-user-search">
      <input
        type="text"
        className="manage-user-search-input"
        placeholder="🔍 Search by name, email, or role..."
        value={userSearch}
        onChange={(e) => setUserSearch(e.target.value)}
      />
      <button className="manage-user-refresh-btn" onClick={fetchUsers}>
        🔄 Refresh
      </button>
    </div>

    {/* Users Table */}
    <div className="manage-user-table-wrapper">
      {loadingUsers ? (
        <p className="manage-user-loading">Loading users...</p>
      ) : filteredUsers.length === 0 ? (
        <p className="manage-user-empty">No users found.</p>
      ) : (
        <table className="manage-user-table">
          <thead>
            <tr>
              <th>#</th>
              <th>First Name</th>
              <th>Last Name</th>
              <th>Email</th>
              <th>Role</th>
              <th>Specialization</th>
              <th>Contact No</th>
              <th>Actions</th>
            </tr>
          </thead>
          <tbody>
            {filteredUsers.map((user, index) => (
              <tr key={user.id}>
                <td>{index + 1}</td>
                <td>{user.firstName}</td>
                <td>{user.lastName}</td>
                <td>{user.email}</td>
                <td>
                  <span className={`role-badge role-${user.role}`}>
                    {user.role}
                  </span>
                </td>
                <td>{user.specialization || "—"}</td>
                <td>{user.contactNo || "—"}</td>
                <td>
                  <button
                    className="manage-user-edit-btn"
                    onClick={() => openEditModal(user)}
                    title="Edit User"
                  >
                    ✏️
                  </button>
                  <button
                    className="manage-user-delete-btn"
                    onClick={() => openDeleteModal(user)}
                    title="Delete User"
                  >
                    🗑️
                  </button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      )}
    </div>

    {/* ============ DELETE MODAL ============ */}
    {deleteModal.open && (
      <div className="mu-modal-overlay">
        <div className="mu-modal-content">
          <div className="mu-modal-header">
            <h3>🗑️ Delete User</h3>
            <button
              className="mu-modal-close"
              onClick={() => setDeleteModal({ open: false, user: null })}
            >
              ×
            </button>
          </div>
          <div className="mu-modal-body">
            <p>Are you sure you want to delete this user?</p>
            <div className="mu-delete-info">
              <strong>{deleteModal.user?.firstName} {deleteModal.user?.lastName}</strong>
              <br />
              <small>{deleteModal.user?.email}</small>
            </div>
            <p className="mu-warning-text">
              ⚠️ This action cannot be undone.
            </p>
            <div className="mu-password-input">
              <label>Enter Authorisation Code *</label>
              <input
                type="password"
                placeholder="Enter authorisation code"
                value={authCode}
                onChange={(e) => setAuthCode(e.target.value)}
                autoComplete="off"
              />
              {authError && (
                <p className="mu-error-text">{authError}</p>
              )}
            </div>
          </div>
          <div className="mu-modal-footer">
            <button
              className="mu-btn-cancel"
              onClick={() => {
                setDeleteModal({ open: false, user: null });
                setAuthCode("");
                setAuthError("");
              }}
            >
              Cancel
            </button>
            <button className="mu-btn-delete" onClick={confirmDelete}>
              Delete User
            </button>
          </div>
        </div>
      </div>
    )}

    {/* ============ EDIT MODAL ============ */}
    {editModal.open && (
      <div className="mu-modal-overlay">
        <div className="mu-modal-content mu-modal-large">
          <div className="mu-modal-header">
            <h3>✏️ Edit User Account</h3>
            <button
              className="mu-modal-close"
              onClick={() => setEditModal({ open: false, user: null })}
            >
              ×
            </button>
          </div>
          <div className="mu-modal-body">
            <div className="mu-edit-grid">
              {/* Email - Read Only */}
              <div className="mu-form-group mu-full-width">
                <label>Email (Cannot be changed)</label>
                <input
                  type="email"
                  value={editModal.user?.email || ""}
                  readOnly
                  className="mu-input mu-input-readonly"
                  disabled
                />
              </div>

              <div className="mu-form-group">
                <label>First Name</label>
                <input
                  type="text"
                  className="mu-input"
                  value={editForm.firstName}
                  onChange={(e) =>
                    setEditForm({ ...editForm, firstName: e.target.value })
                  }
                />
              </div>

              <div className="mu-form-group">
                <label>Last Name</label>
                <input
                  type="text"
                  className="mu-input"
                  value={editForm.lastName}
                  onChange={(e) =>
                    setEditForm({ ...editForm, lastName: e.target.value })
                  }
                />
              </div>

              <div className="mu-form-group">
                <label>Role</label>
                <select
                  className="mu-input"
                  value={editForm.role}
                  onChange={(e) =>
                    setEditForm({ ...editForm, role: e.target.value })
                  }
                >
                  <option value="">Select Role</option>
                  <option value="consultant">consultant</option>
                  <option value="admin">admin</option>
                  <option value="sub-admin">sub-admin</option>
                </select>
              </div>

              <div className="mu-form-group">
                <label>Specialization</label>
                <input
                  type="text"
                  className="mu-input"
                  value={editForm.specialization}
                  onChange={(e) =>
                    setEditForm({ ...editForm, specialization: e.target.value })
                  }
                />
              </div>

              <div className="mu-form-group mu-full-width">
                <label>Contact Number</label>
                <input
                  type="tel"
                  className="mu-input"
                  value={editForm.contactNo}
                  maxLength="10"
                  onChange={(e) => {
                    const value = e.target.value.replace(/\D/g, "").slice(0, 10);
                    setEditForm({ ...editForm, contactNo: value });
                  }}
                />
              </div>
            </div>
          </div>
          <div className="mu-modal-footer">
            <button
              className="mu-btn-cancel"
              onClick={() => setEditModal({ open: false, user: null })}
            >
              Cancel
            </button>
            <button className="mu-btn-save" onClick={confirmEdit}>
              💾 Save Changes
            </button>
          </div>
        </div>
      </div>
    )}
  </div>
)}



{/********************************************** CREATE USER ACCOUNT *******************************************************/}

{selectedOption === "createUserAccount" && (
  <div className="admin-panel-wrapper">
    <h1 className="admin-panel-title">Create User Account</h1>
    <div className="admin-panel-form">
      {/* Input Fields */}
      <input 
        type="email" 
        className="admin-panel-input" 
        placeholder="Email" 
        value={email} 
        onChange={(e) => setEmail(e.target.value)} 
      />

      <div style={{ position: "relative", width: "100%" }}>
        <input
          type={showPassword ? "text" : "password"}
          placeholder="Password"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          style={{
            width: "100%",
            padding: "12px 50px 12px 15px",
            border: "2px solid #ccc",
            borderRadius: "5px",
            outline: "none",
            fontSize: "16px",
            transition: "all 0.3s ease",
            boxShadow: "inset 0 2px 5px rgba(0, 0, 0, 0.1)",
            margin: "0",
            boxSizing: "border-box",
            marginBottom: "15px"
          }}
        />
        <button
          type="button"
          onClick={() => setShowPassword(!showPassword)}
          style={{
            position: "absolute",
            top: "50%",
            right: "15px",
            transform: "translateY(-50%)",
            background: "transparent",
            border: "none",
            cursor: "pointer",
            color: "#aaa",
            transition: "color 0.3s",
            padding: "5px",
            borderRadius: "50%",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          {showPassword ? <EyeOff size={20} /> : <Eye size={20} />}
        </button>
      </div>

      <select
        className="admin-panel-select"
        value={role}
        onChange={(e) => setRole(e.target.value)}
      >
        <option value="">Select Role</option>
        <option value="consultant">consultant</option>
      </select>

      <input
        type="text"
        className="admin-panel-input"
        placeholder="First Name"
        value={firstName}
        onChange={(e) => setFirstName(e.target.value)}
      />
      <input
        type="text"
        className="admin-panel-input"
        placeholder="Last Name"
        value={lastName}
        onChange={(e) => setLastName(e.target.value)}
      />
      <input
        type="text"
        className="admin-panel-input"
        placeholder="Specialization"
        value={specialization}
        onChange={(e) => setSpecialization(e.target.value)}
      />
      <input
        type="tel"
        className="admin-panel-input"
        placeholder="Contact Number"
        value={contactNo}
        onChange={(e) => {
          const value = e.target.value.replace(/\D/g, '').slice(0, 10);
          setContactNo(value);
        }}
        maxLength="10"
      />

      <button className="admin-panel-button" onClick={createAccount}>
        Create Account
      </button>
    </div>
  </div>
)}












 {/**********************************  birthday message  ******************************************/}

{selectedOption === "birthdayMessage" && (
  <div className="birthday-message-panel">
    <div className="birthday-message-header">
      <h2>🎂 Send Birthday Wishes</h2>
      <button
        className="btn-refresh-dash"
        onClick={fetchBirthdayPatients}
        disabled={birthdayLoading}
      >
        {birthdayLoading ? '⏳ Loading...' : '🔄 Refresh'}
      </button>
    </div>

    {birthdayError && (
      <div className="error-message">
        <span>❌</span> {birthdayError}
      </div>
    )}

    {/* TODAY'S BIRTHDAYS */}
    <div className="birthday-section">
      <h3>🎉 Today's Birthdays ({todayBirthdays.length})</h3>

      {birthdayLoading ? (
        <div className="loading">
          <span className="spinner-dark"></span> Loading birthdays...
        </div>
      ) : todayBirthdays.length === 0 ? (
        <div className="empty-state">
          <span>🎈</span>
          <p>No birthdays today</p>
          <small>Check back tomorrow!</small>
        </div>
      ) : (
        <div className="birthday-list">
          {todayBirthdays.map((patient) => (
            <div key={patient.id} className="birthday-card">
              <div className="birthday-patient-info">
                <div className="birthday-avatar">
                  {patient.name?.charAt(0)?.toUpperCase() || '?'}
                </div>
                <div>
                  <h4>{patient.name}</h4>
                  <p>📞 {patient.telephoneNo || '-'}</p>
                  <p>🎂 Turning {calculateAge(patient.dateOfBirth) + 1} years old</p>
                  {patient.sex && <span className={`gender-badge ${patient.sex?.toLowerCase()}`}>{patient.sex}</span>}
                </div>
              </div>

              <div className="birthday-actions">
                <button
                  className="btn-preview-en"
                  onClick={() => openBirthdayModal(patient, 'english')}
                >
                  🇬🇧 English Wish
                </button>
                <button
                  className="btn-preview-si"
                  onClick={() => openBirthdayModal(patient, 'sinhala')}
                >
                  🇱🇰 සිංහල සුබ පැතුම
                </button>
              </div>
            </div>
          ))}
        </div>
      )}
    </div>

    {/* UPCOMING BIRTHDAYS (Next 30 days) */}
    <div className="birthday-section">
      <h3>📅 Upcoming Birthdays (Next 30 Days) — {upcomingBirthdays.length}</h3>

      {upcomingBirthdays.length === 0 ? (
        <p className="empty-text">No upcoming birthdays in the next 30 days</p>
      ) : (
        <div className="table-wrapper">
          <table>
            <thead>
              <tr>
                <th>#</th>
                <th>Name</th>
                <th>Phone</th>
                <th>Birthday</th>
                <th>Days Left</th>
                <th>Action</th>
              </tr>
            </thead>
            <tbody>
              {upcomingBirthdays.map((patient, index) => (
                <tr key={patient.id}>
                  <td>{index + 1}</td>
                  <td>{patient.name}</td>
                  <td>{patient.telephoneNo || '-'}</td>
                  <td>{formatBirthday(patient.dateOfBirth)}</td>
                  <td>
                    <span className="days-badge">
                      {daysUntilBirthday(patient.dateOfBirth)} days
                    </span>
                  </td>
                  <td>
                    <button
                      className="btn-edit"
                      onClick={() => openBirthdayModal(patient, 'english')}
                    >
                      ✉️ Send
                    </button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </div>

    {/* BIRTHDAY MESSAGE MODAL */}
    {showBirthdayModal && selectedBirthdayPatient && (
      <div
        className="modal-overlay"
        onClick={(e) => {
          if (e.target === e.currentTarget) {
            setShowBirthdayModal(false);
            setSelectedBirthdayPatient(null);
          }
        }}
      >
        <div className="modal-content birthday-modal">
          <div className="modal-header">
            <h3>🎂 Birthday Wish — {selectedBirthdayPatient.name}</h3>
            <button
              className="modal-close"
              onClick={() => {
                setShowBirthdayModal(false);
                setSelectedBirthdayPatient(null);
              }}
            >
              ×
            </button>
          </div>

          {/* Language Tabs */}
          <div className="lang-tabs">
            <button
              className={`lang-tab ${birthdayLanguage === 'english' ? 'active' : ''}`}
              onClick={() => setBirthdayLanguage('english')}
            >
              🇬🇧 English
            </button>
            <button
              className={`lang-tab ${birthdayLanguage === 'sinhala' ? 'active' : ''}`}
              onClick={() => setBirthdayLanguage('sinhala')}
            >
              🇱🇰 සිංහල
            </button>
          </div>

          {/* Message Preview */}
          <div className="message-preview">
            <label>Message Preview:</label>
            <textarea
              className="birthday-textarea"
              value={birthdayLanguage === 'english' ? englishWish : sinhalaWish}
              onChange={(e) => {
                if (birthdayLanguage === 'english') {
                  setEnglishWish(e.target.value);
                } else {
                  setSinhalaWish(e.target.value);
                }
              }}
              rows="6"
            />
          </div>

          {/* Send Options */}
          <div className="send-options">
            <h4>Send via:</h4>
            <div className="send-buttons">
              <button
                className="btn-whatsapp"
                onClick={() => sendWhatsApp(selectedBirthdayPatient, birthdayLanguage)}
              >
                💬 WhatsApp
              </button>
              <button
                className="btn-sms"
                onClick={() => sendSMS(selectedBirthdayPatient, birthdayLanguage)}
              >
                📱 SMS
              </button>
              <button
                className="btn-copy"
                onClick={() => {
                  const text = birthdayLanguage === 'english' ? englishWish : sinhalaWish;
                  navigator.clipboard.writeText(text);
                  alert('✅ Message copied to clipboard!');
                }}
              >
                📋 Copy
              </button>
            </div>
          </div>

          <div className="form-actions">
            <button
              type="button"
              className="btn-cancel"
              onClick={() => {
                setShowBirthdayModal(false);
                setSelectedBirthdayPatient(null);
              }}
            >
              Close
            </button>
          </div>
        </div>
      </div>
    )}
  </div>
)}




        {/**********************************  DASHBOARD  ******************************************/}
        {selectedOption === "dashboard" && (
          <div className="dashboard-panel">
            <div className="dashboard-header">
              <h2>📊 Dashboard</h2>
              <button
                className="btn-refresh-dash"
                onClick={fetchDashboardStats}
                disabled={dashboardLoading}
              >
                {dashboardLoading ? '⏳ Loading...' : '🔄 Refresh'}
              </button>
            </div>

            {dashboardError && (
              <div className="error-message">
                <span>❌</span> {dashboardError}
              </div>
            )}

            {dashboardLoading && !dashboardStats.patientCount ? (
              <div className="loading">
                <span className="spinner-dark"></span> Loading dashboard...
              </div>
            ) : (
              <>
                <div className="stats-grid">
                  <div className="stat-card patient-card">
                    <div className="stat-icon">👥</div>
                    <div className="stat-content">
                      <h3>{dashboardStats.patientCount}</h3>
                      <p>Total Patients</p>
                    </div>
                    <button
                      className="stat-link"
                      onClick={() => setSelectedOption('managePatient')}
                    >
                      View →
                    </button>
                  </div>

                  <div className="stat-card consultant-card">
                    <div className="stat-icon">👨‍⚕️</div>
                    <div className="stat-content">
                      <h3>{dashboardStats.consultantCount}</h3>
                      <p>Total Consultants</p>
                    </div>
                    <button
                      className="stat-link"
                      onClick={() => setSelectedOption('manageConsultant')}
                    >
                      View →
                    </button>
                  </div>

                  <div className="stat-card gender-card">
                    <div className="stat-icon">⚥</div>
                    <div className="stat-content">
                      <h3>{dashboardStats.malePatients + dashboardStats.femalePatients}</h3>
                      <p>Classified Patients</p>
                    </div>
                  </div>

                  <div className="stat-card specialization-card">
                    <div className="stat-icon">🏥</div>
                    <div className="stat-content">
                      <h3>{Object.keys(dashboardStats.specializations).length}</h3>
                      <p>Specializations</p>
                    </div>
                  </div>
                </div>

                <div className="dashboard-row">
                  <div className="dashboard-box">
                    <h3>👥 Patient Gender Breakdown</h3>
                    <div className="gender-stats">
                      <div className="gender-item male">
                        <span className="gender-dot male-dot"></span>
                        <span className="gender-label">Male</span>
                        <span className="gender-count">{dashboardStats.malePatients}</span>
                        <div className="gender-bar">
                          <div
                            className="gender-bar-fill male-bar"
                            style={{
                              width: `${dashboardStats.patientCount ?
                                (dashboardStats.malePatients / dashboardStats.patientCount * 100) : 0}%`
                            }}
                          ></div>
                        </div>
                      </div>

                      <div className="gender-item female">
                        <span className="gender-dot female-dot"></span>
                        <span className="gender-label">Female</span>
                        <span className="gender-count">{dashboardStats.femalePatients}</span>
                        <div className="gender-bar">
                          <div
                            className="gender-bar-fill female-bar"
                            style={{
                              width: `${dashboardStats.patientCount ?
                                (dashboardStats.femalePatients / dashboardStats.patientCount * 100) : 0}%`
                            }}
                          ></div>
                        </div>
                      </div>


                    </div>
                  </div>

                  <div className="dashboard-box">
                    <h3>🏥 Consultant Specializations</h3>
                    {Object.keys(dashboardStats.specializations).length === 0 ? (
                      <p className="empty-text">No consultants yet</p>
                    ) : (
                      <div className="specialization-list">
                        {Object.entries(dashboardStats.specializations).map(([spec, count]) => (
                          <div key={spec} className="spec-row">
                            <span className="spec-name">{spec}</span>
                            <span className="spec-count">{count}</span>
                          </div>
                        ))}
                      </div>
                    )}
                  </div>
                </div>

                <div className="dashboard-row">
                  <div className="dashboard-box">
                    <h3>🆕 Recent Patients</h3>
                    {recentPatients.length === 0 ? (
                      <p className="empty-text">No patients yet</p>
                    ) : (
                      <div className="recent-list">
                        {recentPatients.map(p => (
                          <div key={p.id} className="recent-item">
                            <span className="recent-name">{p.name || 'N/A'}</span>
                            <span className="recent-meta">{p.telephoneNo || '-'}</span>
                          </div>
                        ))}
                      </div>
                    )}
                  </div>

                  <div className="dashboard-box">
                    <h3>🆕 Recent Consultants</h3>
                    {recentConsultants.length === 0 ? (
                      <p className="empty-text">No consultants yet</p>
                    ) : (
                      <div className="recent-list">
                        {recentConsultants.map(c => (
                          <div key={c.id} className="recent-item">
                            <span className="recent-name">{c.name || 'N/A'}</span>
                            <span className="recent-meta">{c.specialization || '-'}</span>
                          </div>
                        ))}
                      </div>
                    )}
                  </div>
                </div>
              </>
            )}
          </div>
        )}





{/*****************************************  CREATE PATIENT *********************************************/}

        {selectedOption === "createPatient" && (
          <div className="content-panel">
            <h2>➕ Create Patient Profile</h2>

            {success && (
              <div className="success-message">
                <span>✅</span> {success}
              </div>
            )}

            {error && (
              <div className="error-message">
                <span>❌</span> {error}
              </div>
            )}

            <form className="patient-form" onSubmit={handleSubmit}>
              <div className="form-row">
                <div className="form-group">
                  <label>Full Name *</label>
                  <input
                    type="text"
                    name="name"
                    placeholder="Enter full name (e.g., K M Sedushi Duhansa)"
                    value={formData.name}
                    onChange={handleChange}
                    required
                    disabled={loading}
                  />
                </div>
                <div className="form-group">
                  <label>Phone Number *</label>
                  <input
                    type="tel"
                    name="telephoneNo"
                    placeholder="Enter phone number (e.g., 0786204962)"
                    value={formData.telephoneNo}
                    onChange={handleChange}
                    required
                    disabled={loading}
                  />
                </div>
              </div>

              <div className="form-row">
                <div className="form-group">
                  <label>Referred By</label>
                  <input
                    type="text"
                    name="referredBy"
                    placeholder="Who referred this patient?"
                    value={formData.referredBy}
                    onChange={handleChange}
                    disabled={loading}
                  />
                </div>
                <div className="form-group">
                  <label>Email</label>
                  <input
                    type="email"
                    name="email"
                    placeholder="Enter email address (optional)"
                    value={formData.email}
                    onChange={handleChange}
                    disabled={loading}
                  />
                </div>
              </div>

              <div className="form-row">
                <div className="form-group">
                  <label>Date of Birth *</label>
                  <input
                    type="date"
                    name="dateOfBirth"
                    value={formData.dateOfBirth}
                    onChange={handleChange}
                    required
                    disabled={loading}
                  />
                </div>
                <div className="form-group">
                  <label>Gender *</label>
                  <select
                    name="sex"
                    value={formData.sex}
                    onChange={handleChange}
                    required
                    disabled={loading}
                  >
                    <option value="">Select Gender</option>
                    <option value="male">Male</option>
                    <option value="female">Female</option>
                    <option value="other">Other</option>
                  </select>
                </div>
              </div>

              <div className="form-row">
                <div className="form-group full-width">
                  <label>Address</label>
                  <textarea
                    name="address"
                    placeholder="Enter full address (e.g., Walasmulla)"
                    rows="3"
                    value={formData.address}
                    onChange={handleChange}
                    disabled={loading}
                  ></textarea>
                </div>
              </div>

              <button type="submit" className="btn-submit green-btn" disabled={loading}>
                {loading ? (
                  <>
                    <span className="spinner"></span> Creating...
                  </>
                ) : (
                  'Create Patient'
                )}
              </button>
            </form>
          </div>
        )}



{/********************************************* MANAGE PATIENTS **********************************/}

        {selectedOption === "managePatient" && (
          <div className="content-panel">
            <h2>👥 Manage Patients</h2>

            <div className="search-bar">
              <input
                type="text"
                placeholder="Search patients by name, phone, or email..."
                value={searchTerm}
                onChange={(e) => setSearchTerm(e.target.value)}
                onKeyPress={(e) => e.key === 'Enter' && searchPatients()}
              />
              <button className="btn-search" onClick={searchPatients}>
                🔍 Search
              </button>
              <button className="btn-refresh" onClick={fetchPatients}>
                🔄 Refresh
              </button>
              <button
                className="btn-clear"
                onClick={() => {
                  setSearchTerm('');
                  fetchPatients();
                }}
              >
                ✖ Clear
              </button>
            </div>

            {loading && (
              <div className="loading">
                <span className="spinner"></span> Loading patients...
              </div>
            )}

            {error && (
              <div className="error-message">
                <strong>⚠️ Error:</strong> {error}
                <br />
                <button onClick={fetchPatients} className="btn-retry">Retry</button>
              </div>
            )}

            <div className="patient-stats">
              Total Patients: <strong>{patients.length}</strong>
            </div>

            <div className="table-wrapper">
              <table>
                <thead>
                  <tr>
                    <th>#</th>
                    <th>Added Date (D/M/Y)</th>
                    <th>Name</th>
                    <th>DOB</th>
                    <th>Age</th>
                    <th>Gender</th>
                    <th>Phone</th>
                    <th>Address</th>
                    <th>Referred By</th>
                    <th>Actions</th>
                  </tr>
                </thead>
              <tbody>
        {sortedPatients.length === 0 && !loading && !error ? (
          <tr>
            <td colSpan="10" style={{ textAlign: 'center', padding: '30px' }}>
              <div className="empty-state">
                <span style={{ fontSize: '40px' }}>📋</span>
                <p>No patients found</p>
                <small>Click Refresh to load data</small>
              </div>
            </td>
          </tr>
        ) : (
          sortedPatients.map((patient, index) => {
            const inv = getOldestInvoice(patient);
            const invDate = inv?.createdAtDate;

            return (
              <tr key={patient.id}>
                <td>{index + 1}</td>

                {/* Patient Added = oldest invoice createdAt */}
                <td>
                  {invDate ? invDate.toLocaleDateString() : '-'}
                </td>

                <td>
                  <div className="patient-name">
                    {patient.profileImage && (
                      <img
                        src={patient.profileImage}
                        alt={patient.name}
                        className="avatar-small"
                        onError={(e) => { e.target.style.display = 'none'; }}
                      />
                    )}
                    <span>{patient.name || 'N/A'}</span>
                  </div>
                </td>

                <td>
                  {patient.dateOfBirth
                    ? new Date(patient.dateOfBirth).toLocaleDateString()
                    : '-'}
                </td>

                <td>
                  {patient.dateOfBirth
                    ? Math.floor(
                        (new Date() - new Date(patient.dateOfBirth)) /
                        (365.25 * 24 * 60 * 60 * 1000)
                      ) + ' yrs'
                    : '-'}
                </td>

                <td>
                  <span className={`gender-badge ${patient.sex?.toLowerCase()}`}>
                    {patient.sex || '-'}
                  </span>
                </td>

                <td>{patient.telephoneNo || '-'}</td>
                <td>{patient.address || '-'}</td>
                <td>{patient.referredBy || patient.email || '-'}</td>

                <td>
                  <button
                    className="btn-edit"
                    onClick={() => handleEdit(patient)}
                    disabled={loading}
                  >
                    ✏️ Edit
                  </button>
                  <button
                    className="btn-delete"
                    onClick={() => deletePatient(patient.id)}
                    disabled={loading}
                  >
                    🗑️ Delete
                  </button>
                </td>
              </tr>
            );
          })
        )}
      </tbody>



      
              </table>
            </div>

            {/* Edit Modal */}
            {showEditModal && editingPatient && (
              <div
                className="modal-overlay"
                onClick={(e) => {
                  if (e.target === e.currentTarget) {
                    setShowEditModal(false);
                    setEditingPatient(null);
                  }
                }}
              >
                <div className="modal-content">
                  <div className="modal-header">
                    <h3>✏️ Edit Patient</h3>
                    <button
                      className="modal-close"
                      onClick={() => {
                        setShowEditModal(false);
                        setEditingPatient(null);
                      }}
                    >
                      ×
                    </button>
                  </div>

                  <form onSubmit={handleEditSubmit}>
                    <div className="form-group">
                      <label>Full Name *</label>
                      <input
                        type="text"
                        name="name"
                        value={editingPatient.name || ''}
                        onChange={handleEditChange}
                        required
                      />
                    </div>

                    <div className="form-row">
                      <div className="form-group">
                        <label>Phone Number *</label>
                        <input
                          type="tel"
                          name="telephoneNo"
                          value={editingPatient.telephoneNo || ''}
                          onChange={handleEditChange}
                          required
                        />
                      </div>

                      <div className="form-group">
                        <label>Referred By</label>
                        <input
                          type="text"
                          name="referredBy"
                          value={editingPatient.referredBy || ''}
                          onChange={handleEditChange}
                        />
                      </div>
                    </div>

                    <div className="form-row">
                      <div className="form-group">
                        <label>Date of Birth *</label>
                        <input
                          type="date"
                          name="dateOfBirth"
                          value={editingPatient.dateOfBirth || ''}
                          onChange={handleEditChange}
                          required
                        />
                      </div>

                      <div className="form-group">
                        <label>Gender *</label>
                        <select
                          name="sex"
                          value={editingPatient.sex || ''}
                          onChange={handleEditChange}
                          required
                        >
                          <option value="">Select Gender</option>
                          <option value="male">Male</option>
                          <option value="female">Female</option>
                          <option value="other">Other</option>
                        </select>
                      </div>
                    </div>

                    <div className="form-group">
                      <label>Address</label>
                      <input
                        type="text"
                        name="address"
                        value={editingPatient.address || ''}
                        onChange={handleEditChange}
                      />
                    </div>

                    <div className="form-group">
                      <label>Email</label>
                      <input
                        type="email"
                        name="email"
                        value={editingPatient.email || ''}
                        onChange={handleEditChange}
                      />
                    </div>

                    <div className="form-actions">
                      <button type="submit" className="btn-save" disabled={loading}>
                        {loading ? '⏳ Saving...' : '💾 Save Changes'}
                      </button>
                      <button
                        type="button"
                        className="btn-cancel"
                        onClick={() => {
                          setShowEditModal(false);
                          setEditingPatient(null);
                        }}
                        disabled={loading}
                      >
                        ❌ Cancel
                      </button>
                    </div>
                  </form>
                </div>
              </div>
            )}
          </div>
        )}




  {/**************************************************** CREATE CONSULTANT **************************************/}

        {selectedOption === "createConsultant" && (
          <div className="content-panel">
            <h2>➕ Create Consultant</h2>

            {consultantSuccess && (
              <div className="success-message">
                <span>✅</span> {consultantSuccess}
              </div>
            )}

            {consultantError && (
              <div className="error-message">
                <span>❌</span> {consultantError}
              </div>
            )}

            <form className="consultant-form" onSubmit={handleConsultantSubmit}>
              <div className="form-row">
                <div className="form-group">
                  <label>Consultant's Name *</label>
                  <input
                    type="text"
                    placeholder="Enter consultant name"
                    value={consultantName}
                    onChange={(e) => setConsultantName(e.target.value)}
                    required
                    disabled={consultantLoading}
                  />
                </div>
              </div>

              <div className="form-row">
                <div className="form-group">
                  <label>Consultant's Email *</label>
                  <input
                    type="email"
                    placeholder="Enter consultant Email"
                    value={consultantEmail}
                    onChange={(e) => setConsultantEmail(e.target.value)}
                    required
                    disabled={consultantLoading}
                  />
                </div>
              </div>


              <div className="form-row">
                <div className="form-group">
                  <label>Specialization *</label>
                  <input
                    type="text"
                    placeholder="Enter Specialization"
                    value={consultantSpecialization}
                    onChange={(e) => setConsultantSpecialization(e.target.value)}
                    required
                    disabled={consultantLoading}
                  />
                </div>
              </div>

              <div className="form-row">
                <div className="form-group">
                  <label>Phone *</label>
                  <input
                    type="tel"
                    placeholder="Enter phone number"
                    value={consultantPhone}
                    onChange={(e) => setConsultantPhone(e.target.value)}
                    required
                    disabled={consultantLoading}
                  />
                </div>
              </div>

              <button type="submit" className="btn-submit green-btn" disabled={consultantLoading}>
                {consultantLoading ? (
                  <>
                    <span className="spinner"></span> Creating...
                  </>
                ) : (
                  'Create Consultant'
                )}
              </button>
            </form>
          </div>
        )}





        {/* ================= MANAGE CONSULTANTS ================= */}
        {selectedOption === "manageConsultant" && (
          <div className="content-panel">
            <h2>👨‍⚕️ Manage Consultants</h2>

            <div className="search-bar">
              <input
                type="text"
                placeholder="Search by name, specialization, or phone..."
                value={consultantsSearch}
                onChange={(e) => handleConsultantSearch(e.target.value)}
              />
              <button
                className="btn-search"
                onClick={() => handleConsultantSearch(consultantsSearch)}
              >
                🔍 Search
              </button>
              <button
                className="btn-refresh"
                onClick={fetchConsultants}
                disabled={consultantsLoading}
              >
                🔄 Refresh
              </button>
              {consultantsSearch && (
                <button
                  className="btn-clear"
                  onClick={() => handleConsultantSearch('')}
                >
                  ✖ Clear
                </button>
              )}
            </div>

            <div className="patient-stats">
              Total Consultants: <strong>{consultantsFiltered.length}</strong>
              {consultantsSearch && ` (filtered from ${consultants.length})`}
            </div>

            {consultantsLoading && (
              <div className="loading">
                <span className="spinner-dark"></span> Loading consultants...
              </div>
            )}

            {consultantsError && (
              <div className="error-message">
                <span>❌</span> {consultantsError}
                <br />
                <button onClick={fetchConsultants} className="btn-retry">Retry</button>
              </div>
            )}

            <div className="table-wrapper">
              <table>
                <thead>
                  <tr>
                    <th>#</th>
                    <th>Consultant's Name</th>
                    <th>Email</th>
                    <th>Specialization</th>
                    <th>Phone</th>
                    <th>Actions</th>
                  </tr>
                </thead>
                <tbody>
                  {consultantsFiltered.length === 0 && !consultantsLoading ? (
                    <tr>
                      <td colSpan="5">
                        <div className="empty-state">
                          <span>👨‍⚕️</span>
                          <p>No consultants found</p>
                          <small>
                            {consultantsSearch
                              ? 'Try a different search term'
                              : 'Create a consultant to get started'}
                          </small>
                        </div>
                      </td>
                    </tr>
                  ) : (
                    consultantsFiltered.map((consultant, index) => (
                      <tr key={consultant.id}>
                        <td>{index + 1}</td>
                        <td>
                          <span>{consultant.name || '-'}</span>
                        </td>
                        <td>
                          <span>{consultant.email || '-'}</span>
                        </td>
                        <td>
                          <span className="specialization-badge">
                            {consultant.specialization || '-'}
                          </span>
                        </td>
                        <td>{consultant.telephoneNo || '-'}</td>
                        <td>
                          <button
                            className="btn-edit"
                            onClick={() => handleEditClick(consultant)}
                            disabled={consultantsLoading}
                          >
                            ✏️ Edit
                          </button>
                          <button
                            className="btn-delete"
                            onClick={() => handleDeleteConsultant(consultant.id)}
                            disabled={consultantsLoading}
                          >
                            🗑️ Delete
                          </button>
                        </td>
                      </tr>
                    ))
                  )}
                </tbody>
              </table>
            </div>

            {/* Edit Consultant Modal */}
            {showEditConsultantModal && editingConsultant && (
              <div
                className="modal-overlay"
                onClick={(e) => {
                  if (e.target === e.currentTarget) {
                    setShowEditConsultantModal(false);
                    setEditingConsultant(null);
                  }
                }}
              >
                <div className="modal-content">
                  <div className="modal-header">
                    <h3>✏️ Edit Consultant</h3>
                    <button
                      className="modal-close"
                      onClick={() => {
                        setShowEditConsultantModal(false);
                        setEditingConsultant(null);
                      }}
                    >
                      ×
                    </button>
                  </div>

                  <form onSubmit={handleUpdateConsultant}>
                    <div className="form-group">
                      <label>Consultant's Name *</label>
                      <input
                        type="text"
                        value={editingConsultant.name}
                        onChange={(e) => setEditingConsultant({
                          ...editingConsultant,
                          name: e.target.value
                        })}
                        required
                        disabled={consultantsLoading}
                      />
                    </div>

                    <div className="form-group">
                      <label>Email *</label>
                      <input
                        type="email"
                        value={editingConsultant.email}
                        onChange={(e) => setEditingConsultant({
                          ...editingConsultant,
                          email: e.target.value
                        })}
                        required
                        disabled={consultantsLoading}
                      />
                    </div>

                    <div className="form-group">
                      <label>Specialization *</label>
                      <input
                        type="text"
                        value={editingConsultant.specialization}
                        onChange={(e) => setEditingConsultant({
                          ...editingConsultant,
                          specialization: e.target.value
                        })}
                        required
                        disabled={consultantsLoading}
                      />
                    </div>

                    <div className="form-group">
                      <label>Phone *</label>
                      <input
                        type="tel"
                        value={editingConsultant.telephoneNo}
                        onChange={(e) => setEditingConsultant({
                          ...editingConsultant,
                          telephoneNo: e.target.value
                        })}
                        required
                        disabled={consultantsLoading}
                      />
                    </div>

                    <div className="form-actions">
                      <button
                        type="submit"
                        className="btn-save"
                        disabled={consultantsLoading}
                      >
                        {consultantsLoading ? '⏳ Saving...' : '💾 Save Changes'}
                      </button>
                      <button
                        type="button"
                        className="btn-cancel"
                        onClick={() => {
                          setShowEditConsultantModal(false);
                          setEditingConsultant(null);
                        }}
                        disabled={consultantsLoading}
                      >
                        ❌ Cancel
                      </button>
                    </div>
                  </form>
                </div>
              </div>
            )}
          </div>
        )}

      </div>
    </>
  );
}

export default AdminPanel;